<template>
  <div>
    <div class="wrapper">
      <SiteHeader
        :user="user"
        :show-chrome="!isTelegramPage"
        :nav-items="navItems"
        :active-section="activeSection"
        :is-header-scrolled="isHeaderScrolled"
        :header-scrolled-extra="howPageLockActive"
        :is-menu-open="isMenuOpen"
        :show-guest-upload-in-mobile="true"
        :show-guest-upload-on-desktop="true"
        :upload-disabled="isUploadActionsDisabled"
        :promo-actions-disabled="isPromoActionsDisabled"
        @toggle-menu="toggleMenu"
        @close-menu="closeMenu"
        @nav-click="handleHeaderNavClick"
        @logo-click="redirectToHomePage('link')"
        @open-login="openCommonLoginPopup"
        @guest-upload="handleUploadCheckMainGuest"
        @auth-upload="handleParticipateButtonAuth"
        @account="redirectToPrivatePage"
        @logout="logout"
      />

      <main class="main">
        <section id="hero">
          <div class="container">
            <div class="hero-block">
              <div class="hero-block__title">
                <img src="@/assets/img/hero/hero-title.svg" alt="Первое правило плова">

                <div v-if="!isTelegramAboutPage" class="hero-block__info__button" data-animate="fade-down" data-animate-delay="500">
                  <template v-if="!user">
                    <button :disabled="isPromoActionsDisabled" @click="handleParticipateButton('go')" class="button button-main">
                      Участвовать
                    </button>
                  </template>
                  <template v-else>
                    <button :disabled="isUploadActionsDisabled" @click="handleParticipateButtonAuth('go')" class="button button-main">
                      Участвовать
                    </button>
                  </template>
                </div>

                <div class="hero-block__date">
                  {{ promoRangeText }}
                </div>
              </div>
              <div class="hero-block__image">
                <img src="@/assets/img/hero/hero.png"
                     srcset="@/assets/img/hero/hero@2x.png 2x" alt="">
              </div>
              <div class="hero-block__mobile-image">
                <img src="@/assets/img/hero/mobile-hero.png"
                     srcset="@/assets/img/hero/mobile-hero@2x.png 2x" alt="">
              </div>
            </div>
          </div>
        </section>

        <section id="how-to" class="section-block">
          <div class="container">
            <div class="section-block__title">
              Как выиграть призы
            </div>
            <div class="how-to-list">
              <div class="how-to-item">
                <div class="how-to-item__media">
                  <img src="@/assets/img/prizes/prize-1.png"
                       srcset="@/assets/img/prizes/prize-1@2x.png 2x" alt="">
                </div>
                <div class="how-to-item__title">
                  Покупайте рис для плова Мистраль
                </div>
                <div class="how-to-item__action">
                  <button
                    type="button"
                    class="button button-transparent"
                    @click="scrollToSection('products')"
                  >
                    Смотреть продукты
                  </button>
                </div>
              </div>
              <div class="how-to-item">
                <div class="how-to-item__media">
                  <img src="@/assets/img/prizes/prize-2.png"
                       srcset="@/assets/img/prizes/prize-2@2x.png 2x" alt="">
                </div>
                <div class="how-to-item__title">
                  Регистрируйте <br>чеки на сайте
                </div>
                <div class="how-to-item__action">
                  <template v-if="!user">
                    <button :disabled="isPromoActionsDisabled" @click="handleParticipateButton('upload')" class="button button-transparent">
                      Загрузить чек
                    </button>
                  </template>
                  <template v-else>
                    <button :disabled="isUploadActionsDisabled" @click="handleParticipateButtonAuth('upload')" class="button button-transparent">
                      Загрузить чек
                    </button>
                  </template>
                </div>
              </div>
              <div class="how-to-item">
                <div class="how-to-item__media">
                  <img src="@/assets/img/prizes/prize-3.png"
                       srcset="@/assets/img/prizes/prize-3@2x.png 2x" alt="">
                </div>
                <div class="how-to-item__title">
                  Участвуйте в <br>розыгрыше призов
                </div>
                <div class="how-to-item__action">
                  <button
                    type="button"
                    class="button button-transparent"
                    @click="scrollToSection('prizes')"
                  >
                    Смотреть призы
                  </button>
                </div>
              </div>
              <div class="how-to-item">
                <div class="how-to-item__media">
                  <img src="@/assets/img/prizes/prize-4.png"
                       srcset="@/assets/img/prizes/prize-4@2x.png 2x" alt="">
                </div>
                <div class="how-to-item__title">
                  Принимайте участие в<br>интерактиве
                </div>
                <div class="how-to-item__action">
                  <button
                    type="button"
                    class="button button-transparent"
                    @click="onHowToPlayClick"
                  >
                    Играть
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section id="prizes" class="section-block section-block--main-prizes">
          <div class="container">
            <div class="section-block__title">
              Призы
            </div>

            <div v-show="!isMainPrizesMobile" class="main-prizes-list">
              <div class="main-prizes-item">
                <InfoBlock
                  trigger-label="i"
                  aria-label="Подробнее о гарантированном призе"
                  :hover-mode="viewportWidth > 767"
                >
                  <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                  <p>{{ mainPrizesTips.guaranteed }}</p>
                  <p class="main-prizes-tip__more">
                    <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                  </p>
                </InfoBlock>
                <div class="main-prizes-item__media">
                  <img src="@/assets/img/prizes/prize-img-1.png"
                       srcset="@/assets/img/prizes/prize-img-1@2x.png 2x" alt="">
                </div>
                <div class="main-prizes-item__title">
                  Гарантированный приз за прохождение интерактива
                </div>
                <div class="main-prizes-item__text">
                  Авторский рецепт
                </div>
              </div>
              <div class="main-prizes-item">
                <InfoBlock
                  trigger-label="i"
                  aria-label="Подробнее о еженедельном призе"
                  :hover-mode="viewportWidth > 767"
                >
                  <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                  <p>{{ mainPrizesTips.weekly }}</p>
                  <p class="main-prizes-tip__more">
                    <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                  </p>
                </InfoBlock>
                <div class="main-prizes-item__media">
                  <img src="@/assets/img/prizes/prize-img-2.png"
                       srcset="@/assets/img/prizes/prize-img-2@2x.png 2x" alt="">
                </div>
                <div class="main-prizes-item__title">
                  Еженедельный приз
                </div>
                <div class="main-prizes-item__text">
                  Денежные призы номиналом
                  <br>1&nbsp;000&nbsp;₽, 3&nbsp;000&nbsp;₽, 4&nbsp;000&nbsp;₽, 10&nbsp;000&nbsp;₽
                </div>
              </div>
              <div class="main-prizes-item">
                <InfoBlock
                  trigger-label="i"
                  aria-label="Подробнее о специальном призе"
                  :hover-mode="viewportWidth > 767"
                >
                  <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                  <p>{{ mainPrizesTips.special }}</p>
                  <p class="main-prizes-tip__more">
                    <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                  </p>
                </InfoBlock>
                <div class="main-prizes-item__media">
                  <img src="@/assets/img/prizes/prize-img-3.png"
                       srcset="@/assets/img/prizes/prize-img-3@2x.png 2x" alt="">
                </div>
                <div class="main-prizes-item__title">
                  Специальный приз за прохождение интерактива
                </div>
                <div class="main-prizes-item__text">
                  Кухонная станция RED Colorсook
                </div>
              </div>
              <div class="main-prizes-item">
                <InfoBlock
                  trigger-label="i"
                  aria-label="Подробнее о главном призе"
                  :hover-mode="viewportWidth > 767"
                >
                  <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                  <p>{{ mainPrizesTips.grand }}</p>
                  <p class="main-prizes-tip__more">
                    <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                  </p>
                </InfoBlock>
                <div class="main-prizes-item__media">
                  <img src="@/assets/img/prizes/main-full-prize.png"
                       srcset="@/assets/img/prizes/main-full-prize@2x.png 2x" alt="">
                </div>
              </div>
            </div>

            <div v-show="isMainPrizesMobile" class="main-prizes-section__mobile">
              <Swiper
                class="prizes-mobile-swiper main-prizes-intro-swiper"
                :key="'main-prizes-intro'"
                :modules="howSwiperModules"
                :slides-per-view="1"
                :space-between="12"
                :speed="300"
                :pagination="mainPrizesIntroPagination"
                @swiper="onMainPrizesIntroSwiperInit"
                @slideChange="onMainPrizesIntroSlideChange"
              >
                <SwiperSlide class="prizes-mobile-slide">
                  <div class="prizes-mobile-card prizes-mobile-card--intro">
                    <InfoBlock
                      trigger-label="i"
                      aria-label="Подробнее о главном призе"
                      :hover-mode="viewportWidth > 767"
                    >
                      <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                      <p>{{ mainPrizesTips.grand }}</p>
                      <p class="main-prizes-tip__more">
                        <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                      </p>
                    </InfoBlock>
                    <div class="main-prizes-item main-prizes-item--media-only">
                      <div class="main-prizes-item__media">
                        <img src="@/assets/img/prizes/main-prize-mobile.png"
                             srcset="@/assets/img/prizes/main-prize-mobile@2x.png 2x" alt="">
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide class="prizes-mobile-slide">
                  <div class="prizes-mobile-card prizes-mobile-card--intro">
                    <InfoBlock
                      trigger-label="i"
                      aria-label="Подробнее о еженедельном призе"
                      :hover-mode="viewportWidth > 767"
                    >
                      <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                      <p>{{ mainPrizesTips.weekly }}</p>
                      <p class="main-prizes-tip__more">
                        <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                      </p>
                    </InfoBlock>
                    <div class="main-prizes-item">
                      <div class="main-prizes-item__media">
                        <img src="@/assets/img/prizes/prize-img-2.png"
                             srcset="@/assets/img/prizes/prize-img-2@2x.png 2x" alt="">
                      </div>
                      <div class="main-prizes-item__title">
                        Еженедельный приз
                      </div>
                      <div class="main-prizes-item__text">
                        Денежные призы номиналом
                        <br>1&nbsp;000&nbsp;₽, 3&nbsp;000&nbsp;₽, 4&nbsp;000&nbsp;₽, 10&nbsp;000&nbsp;₽
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide class="prizes-mobile-slide">
                  <div class="prizes-mobile-card prizes-mobile-card--intro">
                    <InfoBlock
                      trigger-label="i"
                      aria-label="Подробнее о гарантированном призе"
                      :hover-mode="viewportWidth > 767"
                    >
                      <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                      <p>{{ mainPrizesTips.guaranteed }}</p>
                      <p class="main-prizes-tip__more">
                        <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                      </p>
                    </InfoBlock>
                    <div class="main-prizes-item">
                      <div class="main-prizes-item__media">
                        <img src="@/assets/img/prizes/prize-img-1.png"
                             srcset="@/assets/img/prizes/prize-img-1@2x.png 2x" alt="">
                      </div>
                      <div class="main-prizes-item__title">
                        Гарантированный приз за прохождение интерактива
                      </div>
                      <div class="main-prizes-item__text">
                        Авторский рецепт
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide class="prizes-mobile-slide">
                  <div class="prizes-mobile-card prizes-mobile-card--intro">
                    <InfoBlock
                      trigger-label="i"
                      aria-label="Подробнее о специальном призе"
                      :hover-mode="viewportWidth > 767"
                    >
                      <p class="main-prizes-tip__title">{{ mainPrizesTipTitle }}</p>
                      <p>{{ mainPrizesTips.special }}</p>
                      <p class="main-prizes-tip__more">
                        <a :href="rulesUrl" target="_blank" rel="noopener noreferrer">Правила акции</a>
                      </p>
                    </InfoBlock>
                    <div class="main-prizes-item">
                      <div class="main-prizes-item__media">
                        <img src="@/assets/img/prizes/prize-img-3.png"
                             srcset="@/assets/img/prizes/prize-img-3@2x.png 2x" alt="">
                      </div>
                      <div class="main-prizes-item__title">
                        Специальный приз за прохождение интерактива
                      </div>
                      <div class="main-prizes-item__text">
                        Кухонная станция RED Colorсook
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div
                id="main-prizes-intro-pagination"
                class="main-prizes-intro-pagination"
                aria-hidden="true"
              ></div>
            </div>
          </div>
        </section>


        <section class="section-block" id="interactive">
          <div class="container">
            <div class="section-block__title">
              Интерактив
            </div>
            <div class="interactive-block">
              <div class="interactive-block__left">
                <div class="interactive-block__title">
                  Соберите
                  <br>правильный
                  <br>плов
                </div>
                <div class="interactive-block__action">
                  <button type="button" class="button button-blue" :disabled="isPromoActionsDisabled" @click="handleInteractiveBlockPlay">
                    Играть
                  </button>
                </div>
                <div class="interactive-block__kazans">
                  <div class="interactive-block__kazans__title">
                    {{ interactiveRiceProgressLabel }}
                  </div>
                  <div class="interactive-block__kazans__progress">
                    <img
                      v-for="(slot, si) in interactiveKazanSlots"
                      :key="'ik-d-' + si"
                      :src="slot.done ? kazanDoneImg : kazanLockedImg"
                      alt=""
                    >
                  </div>
                </div>
              </div>
              <div class="interactive-block__right">
                <img src="@/assets/img/blocks/interactive-main.png"
                     srcset="@/assets/img/blocks/interactive-main@2x.png 2x" alt="">
              </div>
              <div class="interactive-block__kazans interactive-block__kazans--mobile">
                <div class="interactive-block__kazans__title">
                  {{ interactiveRiceProgressLabel }}
                </div>
                <div class="interactive-block__kazans__progress">
                  <img
                    v-for="(slot, si) in interactiveKazanSlots"
                    :key="'ik-m-' + si"
                    :src="slot.done ? kazanDoneImg : kazanLockedImg"
                    alt=""
                  >
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="section-block" id="products">
          <div class="container">
            <div class="section-block__title">
              продукты, участвующие в акции
            </div>
            <div v-show="!isMainPrizesMobile" class="products-action-list">
              <div
                v-for="item in riceCards"
                :key="'rice-d-' + item.id"
                class="products-action-item"
                :style="riceCardStyle(item.background)"
              >
                <div class="products-action-item__left">
                  <div class="products-action-item__type">{{ item.rice_type }}</div>
                  <div class="products-action-item__name">Для плова</div>
                  <div class="products-action-item__title">{{ item.title }}</div>
                  <div class="products-action-item__gr">500 г</div>
                </div>
                <div class="products-action-item__right">
                  <img
                    :src="riceImageSrc(item.image)"
                    :alt="[item.rice_type, item.title].filter(Boolean).join(', ') || 'Продукт'"
                  >
                </div>
              </div>
            </div>

            <div v-show="isMainPrizesMobile" class="products-section__mobile">
              <Swiper
                class="prizes-mobile-swiper products-mobile-swiper"
                :key="'products-mobile-' + riceCards.length"
                :modules="riceSwiperModules"
                :slides-per-view="1"
                :space-between="12"
                :speed="300"
                :loop="riceCards.length > 1"
                :pagination="productsMobilePagination"
                :autoplay="productsMobileAutoplay"
                @swiper="onProductsMobileSwiperInit"
                @slideChange="onProductsMobileSlideChange"
              >
                <SwiperSlide
                  v-for="item in riceCards"
                  :key="'rice-m-' + item.id"
                  class="prizes-mobile-slide"
                >
                  <div
                    class="products-action-item"
                    :style="riceCardStyle(item.background)"
                  >
                    <div class="products-action-item__left">
                      <div class="products-action-item__type">{{ item.rice_type }}</div>
                      <div class="products-action-item__name">Для плова</div>
                      <div class="products-action-item__title">{{ item.title }}</div>
                      <div class="products-action-item__gr">500 г</div>
                    </div>
                    <div class="products-action-item__right">
                      <img
                        :src="riceImageSrc(item.image)"
                        :alt="[item.rice_type, item.title].filter(Boolean).join(', ') || 'Продукт'"
                      >
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div
                id="products-section-pagination"
                class="products-section__pagination"
                aria-hidden="true"
              ></div>
            </div>
          </div>
        </section>

        <section class="section-block" id="stores">
          <div class="container">
            <div class="section-block__title">
              Где купить
            </div>
            <div v-show="!isMainPrizesMobile" class="stores">
              <div
                v-for="shop in shopCards"
                :key="'store-d-' + shop.id"
                class="store-item"
              >
                <a
                  class="store-item__link"
                  :href="shopHref(shop.url)"
                  :target="shopHasExternalUrl(shop.url) ? '_blank' : undefined"
                  :rel="shopHasExternalUrl(shop.url) ? 'noopener noreferrer' : undefined"
                  @click="onShopLinkClick($event, shop.url)"
                ></a>
                <img
                  :src="shopImageSrc(shop.image)"
                  alt=""
                >
              </div>
            </div>

            <div v-show="isMainPrizesMobile" class="stores-section__mobile">
              <Swiper
                class="prizes-mobile-swiper stores-mobile-swiper"
                :key="'stores-mobile-' + shopCards.length"
                :modules="howSwiperModules"
                :slides-per-view="1"
                :space-between="12"
                :speed="300"
                :pagination="storesMobilePagination"
                @swiper="onStoresMobileSwiperInit"
                @slideChange="onStoresMobileSlideChange"
              >
                <SwiperSlide
                  v-for="shop in shopCards"
                  :key="'store-m-' + shop.id"
                  class="prizes-mobile-slide"
                >
                  <div class="store-item">
                    <a
                      class="store-item__link"
                      :href="shopHref(shop.url)"
                      :target="shopHasExternalUrl(shop.url) ? '_blank' : undefined"
                      :rel="shopHasExternalUrl(shop.url) ? 'noopener noreferrer' : undefined"
                      @click="onShopLinkClick($event, shop.url)"
                    ></a>
                    <img
                      :src="shopImageSrc(shop.image)"
                      alt=""
                    >
                  </div>
                </SwiperSlide>
              </Swiper>
              <div
                id="stores-section-pagination"
                class="stores-section__pagination"
                aria-hidden="true"
              ></div>
            </div>
          </div>
        </section>

        <section
            v-if="showWinnersSection"
            class="section-block winners-section"
            :class="{ 'winners-section--telegram': isTelegramWinnersPage }"
            id="winners"
            data-animate="fade-up"
        >
          <div class="container container--small">
            <div class="section-block__title winners-section__title" data-animate="fade-up">
              Победители
            </div>

            <div class="winners-layout">
              <aside class="winners-layout__nav" aria-label="Фильтр по типу приза и периоду">
                <div class="winners-nav-stack">

                  <!-- Еженедельный + периоды (периоды в API только для weekly) -->
                  <div v-if="winnersPrizeType === 'weekly'" class="winner-group">
                    <div class="winners-nav-slot">
                      <div class="winners-nav-card winners-nav-card--solo">
                        <span class="winners-nav-card__title">Еженедельный приз</span>
                      </div>
                    </div>
                    <div
                        ref="winnersDropdown"
                        class="winners-period-dropdown winners-period-dropdown--always"
                    >
                      <button
                          type="button"
                          class="winners-period-dropdown__trigger winners-period-dropdown__trigger--outline"
                          :class="{ 'is-open': isWinnersPeriodOpen }"
                          :aria-expanded="isWinnersPeriodOpen ? 'true' : 'false'"
                          aria-haspopup="listbox"
                          @click="toggleWinnersPeriodDropdown"
                      >
                        <span>{{ selectedPeriodText }}</span>
                        <span class="winners-period-dropdown__chev" aria-hidden="true" />
                      </button>
                      <ul
                          v-show="isWinnersPeriodOpen"
                          class="winners-period-dropdown__list"
                          role="listbox"
                      >
                        <li
                            v-for="(opt, idx) in winnersPeriodOptions"
                            :key="'p-' + idx + '-' + String(opt.id)"
                            role="presentation"
                        >
                          <button
                              type="button"
                              class="winners-period-dropdown__option"
                              role="option"
                              @click="selectWinnersPeriod(opt)"
                          >
                            {{ opt.label }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-else class="winners-nav-slot">
                    <button
                        type="button"
                        class="winners-nav-btn winners-nav-btn--outline"
                        @click="setWinnersPrizeType('weekly')"
                    >
                      Еженедельный приз
                    </button>
                  </div>

                  <div class="winners-nav-slot">
                    <button
                        v-if="winnersPrizeType !== 'grand'"
                        type="button"
                        class="winners-nav-btn winners-nav-btn--outline"
                        @click="setWinnersPrizeType('grand')"
                    >
                      Главный приз
                    </button>
                    <div v-else class="winners-nav-card winners-nav-card--solo">
                      <span class="winners-nav-card__title">Главный приз</span>
                    </div>
                  </div>

                  <div class="winners-nav-slot">
                    <button
                      v-if="winnersPrizeType !== 'special'"
                      type="button"
                      class="winners-nav-btn winners-nav-btn--outline"
                      @click="setWinnersPrizeType('special')"
                    >
                      Специальный приз
                    </button>
                    <div v-else class="winners-nav-card winners-nav-card--solo">
                      <span class="winners-nav-card__title">Специальный приз</span>
                    </div>
                  </div>
                </div>
              </aside>

              <div class="winners-layout__main">
                <div
                    v-if="winners.length"
                    ref="winnersList"
                    class="winners-list"
                    :class="{ 'winners-list--few': winnersListFewNoScrollbar }"
                    @scroll.passive="handleWinnersScroll"
                >
                  <div class="winners-list-item" v-for="(winner, index) in winners" :key="getWinnerItemKey(winner, index)">
                    <div class="winners-list-item__column winners-list-item__column--name">
                      {{ getWinnerDisplayName(winner) }}
                    </div>
                    <div class="winners-list-item__column winners-list-item__column--email">
                      {{ getWinnerDisplayEmail(winner) }}
                    </div>
                    <div class="winners-list-item__column winners-list-item__column--prize">
                      {{ getWinnerPrizeText(winner) }}
                    </div>
                  </div>
                </div>

                <div v-else-if="loading && !winners.length" class="winners-empty winners-empty--loading">
                  <span class="winners-loading-spinner" aria-hidden="true"></span>
                  <p>Загружаем победителей…</p>
                </div>
                <div v-else-if="winnersFetchError" class="winners-empty winners-empty--error">
                  <p>Не удалось загрузить список победителей.</p>
                  <p>
                    <button type="button" class="button button-white" @click="retryLoadWinners">
                      Повторить
                    </button>
                  </p>
                </div>
                <div v-else-if="noWinners" class="winners-empty">
                  <p>
                    Победителей еще нет, но им можете стать Вы.
                    <br>Загружайте чеки и принимайте участие в розыгрышах!
                  </p>
                  <p>
                    <template v-if="!user">
                      <button :disabled="isPromoActionsDisabled" @click="handleParticipateButton('upload')" class="button button-white">
                        Загрузить чек
                      </button>
                    </template>
                    <template v-else>
                      <button :disabled="isUploadActionsDisabled" @click="handleParticipateButtonAuth('upload')" class="button button-white">
                        Загрузить чек
                      </button>
                    </template>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="showFaqSection" class="section-block" id="faq" data-animate="fade-up">
          <div class="container container--small">
            <div class="section-block__title" data-animate="fade-up">
              Вопросы-ответы
            </div>
            <div class="faq-wrap">
              <div class="faq-block">
                <div
                    class="faq-block-item"
                    v-for="(item, index) in faq"
                    :key="index"
                    data-animate="fade-up"
                    :data-animate-delay="String(Math.min(index * 50, 500))"
                >
                  <button
                      class="faq-block-item__btn"
                      @click="toggleAccordion(index)"
                      :class="{ 'is-opened': openIndex === index }"
                  >
                    <span>{{ item.question }}</span>
                  </button>
                  <div
                      class="faq-block-item__text"
                      v-html="formatText(item.answer)"
                      :class="{ 'is-opened': openIndex === index }"
                  ></div>
                </div>
              </div>
              <div v-if="showFaqQuestion" class="faq-question">
                <div class="faq-question__title">Обратная связь</div>
                <div class="faq-question__text">Если у вас остались какие-либо вопросы, напишите нам!</div>
                <div class="faq-question__action">
                  <button class="button button-main" @click="openQuestionPopup()">Написать</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>

    <div
      v-if="showAccountInteractivePopup"
      class="popup popup--account-interactive-home"
      v-popup-tall
    >
      <div class="popup__overlay" @click="closeAccountInteractivePopup"></div>
      <div class="popup__window popup__window--large">
        <button type="button" class="modal-close" @click="closeAccountInteractivePopup">
          <svg width="40" height="40"><use href="@/assets/img/icons/icons.svg#x"></use></svg>
        </button>
        <div class="modal-content modal-content--account-interactive-home">
          <AccountInteractiveRicePanel
            :won-rice-games="interactiveWonRiceList"
            :chain-access="interactiveWonRiceChainAccess"
            pagination-element-id="account-rice-swiper-pagination-home"
            @upload-check="onAccountInteractiveHomeUploadCheck"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* global ym */
/* global _txq */
import adRiver from '@/services/adriver';
import { ref, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
// import collectionsSwiper from '@/components/CollectionsSwiper.vue';
import { getFeedbackTopics, fetchFAQ, getToken, getUserInfo, removeToken, authorize, register, getMainSettings, sendFeedback, setAuthHeader, sendResetPassword, fetchWinnings, fetchWinningPeriods, fetchQuizPeriods, getPrizes, fetchRiceProducts, fetchShops, fetchWonRiceGames, formatApiErrorResponseMessage } from '@/api';
import { mergePendingIntoWonRiceList } from '@/utils/riceGamePending';
import { parseWonRiceGamesResponse, normalizeWonRiceGamesListForUi } from '@/utils/wonRiceNormalize';
import metrikaMixin from '@/mixins/metrikaMixin';
// const swiperInstance = ref(null);
import { state } from "@/store";
import { feedbackIdentityPrefill } from '@/utils/feedbackFormPrefill';
import { setMobileMenuScrollLock } from '@/utils/documentScrollLock';
import {
  formatRussianMobileE164,
  isValidRussianMobilePhone,
  russianMobilePhoneHint,
} from '@/utils/russianMobilePhone';
import { registerNameSignificantLength } from '@/utils/registerPersonName';
import InfoBlock from '@/components/infoBlock.vue';
import { hasCookieConsent } from '@/utils/cookieConsent';
import { formatPromoRangeRu } from '@/utils/formatPromoRange';
import { blockIfPromoStatusPending, markPromoStatusLoaded } from '@/utils/promoStatus';
import { ANALYTICS_DISABLED } from '@/config/analytics';
import { YANDEX_METRIKA_COUNTER_ID } from '@/utils/metrika';
import SiteHeader from '@/components/layout/SiteHeader.vue';
import AccountInteractiveRicePanel from '@/components/account/AccountInteractiveRicePanel.vue';
import { appRootKey } from '@/injectionKeys';
import kazanDoneImg from '@/assets/img/icons/kazan-main.svg';
import kazanLockedImg from '@/assets/img/icons/kazan-gray.svg';

function getFallbackRiceList() {
  return [
    {
      id: 'rice-fallback-0',
      rice_type: 'Рис круглозерный',
      title: 'по-домашнему',
      background: `url(${require('@/assets/img/products/product-bg-1.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-1.png'),
    },
    {
      id: 'rice-fallback-1',
      rice_type: 'Рис Басмати extra long',
      title: 'бирияни',
      background: `url(${require('@/assets/img/products/product-bg-2.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-2.png'),
    },
    {
      id: 'rice-fallback-2',
      rice_type: 'Рис Самарканд',
      title: 'по-узбекски',
      background: `url(${require('@/assets/img/products/product-bg-3.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-3.png'),
    },
    {
      id: 'rice-fallback-3',
      rice_type: 'Рис Кайсери',
      title: 'по-турецки',
      background: `url(${require('@/assets/img/products/product-bg-6.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-4.png'),
    },
    {
      id: 'rice-fallback-4',
      rice_type: 'Рис Осман',
      title: 'по-восточному',
      background: `url(${require('@/assets/img/products/product-bg-4.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-5.png'),
    },
    {
      id: 'rice-fallback-5',
      rice_type: 'Рис пропаренный',
      title: 'чайханского',
      background: `url(${require('@/assets/img/products/product-bg-5.svg')}) center / cover no-repeat`,
      image: require('@/assets/img/products/rice-6.png'),
    },
  ];
}

function getFallbackShopsList() {
  const urls = [
    'https://www.ozon.ru/search/?text=%D1%80%D0%B8%D1%81%20%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D0%BF%D0%BB%D0%BE%D0%B2',
    'https://www.wildberries.ru/catalog/0/search.aspx?search=%D1%80%D0%B8%D1%81%20%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C',
    'https://samokat.ru/',
    'https://market.yandex.ru/search?text=%D1%80%D0%B8%D1%81%20%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D0%BF%D0%BB%D0%BE%D0%B2',
    'https://magnit.ru/',
    'https://vkusvill.ru/search/?isComplete=0&type=products&q=%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81',
    'https://www.perekrestok.ru/cat/search?search=%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81',
    'https://online.metro-cc.ru/search?q=%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81',
    'https://lenta.com/search/%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81/',
    'https://www.auchan.ru/?utm_referrer=https%3A%2F%2Fyandex.ru%2F',
    'https://www.okeydostavka.ru/webapp/wcs/stores/servlet/SearchDisplay?categoryId=&storeId=10151&catalogId=10551&langId=-20&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&searchSource=Q&pageView=&beginIndex=0&pageSize=72&searchTerm=%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81',
    'https://online.globus.ru/search?q=%D0%BC%D0%B8%D1%81%D1%82%D1%80%D0%B0%D0%BB%D1%8C%20%D1%80%D0%B8%D1%81',
  ];
  const images = [
    require('@/assets/img/stores/Logo-0.svg'),
    require('@/assets/img/stores/Logo-1.svg'),
    require('@/assets/img/stores/Logo-2.svg'),
    require('@/assets/img/stores/Logo-3.svg'),
    require('@/assets/img/stores/Logo-4.svg'),
    require('@/assets/img/stores/Logo-5.svg'),
    require('@/assets/img/stores/Logo-6.svg'),
    require('@/assets/img/stores/Logo-7.svg'),
    require('@/assets/img/stores/Logo-9.svg'),
    require('@/assets/img/stores/Logo-10.svg'),
    require('@/assets/img/stores/Logo-11.svg'),
    require('@/assets/img/stores/Logo-12.svg'),
  ];
  return images.map((image, i) => ({
    id: `shop-fallback-${i}`,
    image,
    url: urls[i] || '#',
  }));
}

export default {
  name: 'HomePage',
  mixins: [metrikaMixin],
  inject: {
    shell: {
      from: appRootKey,
      default: null,
    },
  },
  components: {
    SiteHeader,
    Swiper,
    SwiperSlide,
    InfoBlock,
    AccountInteractiveRicePanel,
  },
  setup() {
    const activeSection = ref('how'); // начальное значение
    const sectionOrder = ['how', 'prizes', 'winners', 'faq', 'feedback']; // порядок

    onMounted(() => {
      const options = {
        root: null,
        rootMargin: '0px 0px -80% 0px', // запускать, когда секция приближается сверху
        threshold: 0,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            if (sectionOrder.includes(id)) {
              activeSection.value = id;
            }
          }
        });
      }, options);

      sectionOrder.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          observer.observe(el);
        }
      });
    });

    return {
      state,
      activeSection,
      navItems: [
        { id: 'hero', href: '/#hero', name: 'Главная' },
        { id: 'prizes', href: '/#prizes', name: 'Призы' },
        { id: 'interactive', href: '/#interactive', name: 'Интерактив' },
        { id: 'products', href: '/#products', name: 'Продукция' },
        { id: 'stores', href: '/#stores', name: 'Где купить' },
        { id: 'faq', href: '/#faq', name: 'Вопросы-ответы' },
      ],
    };
  }
  ,
  data() {
    return {
      isLoadingUser: true,
      openIndex: null,
      mainPrizesTipTitle: 'Как получить приз',
      mainPrizesTips: {
        guaranteed:
          'Пройдите интерактив, чтобы забрать приз. Первая игра доступна всем зарегистрированным пользователям, а каждая следующая (со 2-й по 6-ю) открывается после подтверждения чека.',
        weekly:
          'Загрузите чек и дождитесь его подтверждения. Принятые чеки участвуют в еженедельном розыгрыше призов.',
        special:
          'Соберите все 6 казанов в интерактиве — и вы станете участником розыгрыша кухонной станции RED Colorcook',
        grand:
          'Загрузите не менее 3 чеков и дождитесь их подтверждения — после этого все ваши чеки участвуют в розыгрыше главного приза.',
      },
      availablePrizes: {
        grand: [],
        weekly: [],
        guaranteed: [],
        special: []
      },
      winners: [],
      shopProducts: [],
      shopFallbackList: getFallbackShopsList(),
      limit: 20,
      offset: 0,
      prizeType: '',
      userEmail: '',
      totalCount: 0,
      loading: false,
      prizeTypes: [
        { value: '', label: 'Все призы' },
        { value: 'grand', label: 'Главный' },
        { value: 'monthly', label: 'Ежемесячный' },
      ],
      noWinners: false,
      winnersFetchError: false,
      // Новые переменные для фильтров победителей
      winnersSearchEmail: '',
      winnersPrizeType: 'weekly',
      selectedPeriod: '',
      availablePeriods: [],
      searchTimeout: null, // Таймер для debounce поиска
      notFound: false,
      isMenuOpen: false,
      formSending: false,
      resetPasswordEmail: null,
      isOpen: false,
      selectedText: 'Тема обращения',
      topics: [],
      isWinnersPeriodOpen: false,
      isWinnersPeriodChanged: false,
      selectedPeriodText: 'Весь период',
      utmParams: {},
      clientId: null,
      hasMoreWinners: true,
      isLoading: false,
      activePrizeType: 1,
      isHeaderScrolled: false,
      scrollThreshold: 0,
      rootUrl: window.location.origin,
      userId: '',
      userUuid: '',
      isMobileNavOpened: false,
      faq: [],
      prizes: [],
      user: null,
      showLoginPopup: false,
      showCommonLoginPopup: false,
      showRegisterPopup: false,
      showRegisterPopupSuccess: false,
      showQuestionPopup: false,
      showQuestionPopupSuccess: false,
      showPromoNotStarted: false,
      showPromoEnd: false,
      showEndPopupSuccess: false,
      showResetPasswordPopup: false,
      showBalanceInfo: false,
      showResetPasswordSuccess: false,
      AccountPopup: false,
      questionForm: {
        name: this.user && this.user.first_name ? this.user.first_name : '',
        email: this.user && this.user.email ? this.user.email : '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      },
      filePreviews: [],
      phone_number: '',
      email: '',
      password: '',
      passwordVisible: false,
      registerForm: {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      },
      loginForm: {
        email: '',
        password: '',
      },
      loginFormErrors: {},
      resetPasswordForm: {
        email: '',
      },
      feedbackErrors: {},
      resetPasswordErrors: {},
      errors: {},
      responseError: '',
      registrationSuccessEmail: '',
      days: 0,
      hours: 0,
      minutes: 0,
      timerMessage: '',
      promoDates: '',
      mainSettings: {},
      isFocus: false,
      isChange: false,
      isGuarantedPopap: false,
      isOpenSelect: false,
      selectValue: 'Все призы',
      isHowMobileView: false,
      isHowPinned: false,
      activeHowSlide: 0,
      howSwiper: null,
      mainPrizesIntroSwiper: null,
      productsMobileSwiper: null,
      storesMobileSwiper: null,
      riceProducts: [],
      riceFallbackList: getFallbackRiceList(),
      /** Сырые данные GET /api/quiz/won-rice для баннера «Интерактив» (пусто = гость). */
      interactiveWonRiceList: [],
      /** Цепочка казанов из корня ответа won-rice: available | all_won | not_available */
      interactiveWonRiceChainAccess: 'available',
      kazanDoneImg,
      kazanLockedImg,
      showAccountInteractivePopup: false,
      riceSwiperModules: [Pagination, Autoplay],
      howSwiperModules: [Pagination],
      howSlidesCount: 4,
      viewportWidth: window.innerWidth,
      howSwipeStartX: 0,
      howSwipeStartY: 0,
      howSwipeCurrentX: 0,
      howSwipeCurrentY: 0,
      howSwipeActive: false,
      howTouchLastY: 0,
      howSlideLockUntil: 0,
      howPageLockActive: false,
      howPageLockScrollY: 0,
      howWheelDeltaAcc: 0,
      howWheelDeltaDir: 0,
      howTouchDeltaAcc: 0,
      howTouchDeltaDir: 0,
      howJustLockedUntil: 0,
      howSoftLockUntil: 0,
      sectionsStickyInnerHeight: 0,
      sectionsStickyResizeObserver: null,
      isWeeklySliderDragging: false,
      weeklySliderDragStartX: 0,
      weeklySliderDragStartScrollLeft: 0,
      weeklySliderPointerId: null,
      weeklyWheelLock: false,
      weeklyWheelUnlockTimer: null,
      
    };
  },
  async created() {
    try {
      this.mainSettings = await getMainSettings();
    } catch (error) {
      console.error('Failed to fetch main settings', error);
    }
    this.loadFAQ();
    this.checkAuthentication();
    await this.fetchTimerData();
  },
  beforeUnmount() {
    setMobileMenuScrollLock(false);
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleDynamicButtonClick);
    document.body.classList.remove('is-upload-widget-opened');
    if (this.weeklyWheelUnlockTimer) {
      clearTimeout(this.weeklyWheelUnlockTimer);
      this.weeklyWheelUnlockTimer = null;
    }
    if (this.sectionsStickyResizeObserver) {
      this.sectionsStickyResizeObserver.disconnect();
      this.sectionsStickyResizeObserver = null;
    }
    this.disableHowPageLock();
    if (this.showAccountInteractivePopup) {
      this.closeAccountInteractivePopup();
    }
    this.mainPrizesIntroSwiper = null;
    this.productsMobileSwiper = null;
    this.storesMobileSwiper = null;
  },
  async mounted() {
    // adRiver.trackPageView();
    document.body.classList.add('loading-user'); // Вешаем класс на body
    this.scheduleWinnersDeferredLoad();
    this.initFloatingLabels();
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");
    if (ref) {
      state.ref = ref;
    }
    await this.fetchTopics();
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
    this.addIntersectionObserver();
    this.initScrollAnimations();
    this.getClientId();
    this.getUTMParams();
    this.handleResize();
    this.handleScroll();
    this.updateSectionsStickyInnerHeight();
    this.$nextTick(() => {
      const inner = this.$refs.sectionsStickyInner;
      if (inner && typeof ResizeObserver !== 'undefined') {
        this.sectionsStickyResizeObserver = new ResizeObserver(() => {
          this.updateSectionsStickyInnerHeight();
        });
        this.sectionsStickyResizeObserver.observe(inner);
      }
    });
    this.fetchPrizes();
    this.loadRiceProducts();
    this.loadShops();
    setAuthHeader();
    const token = getToken();
    if (token) {
      setTimeout(async () => {
        try {
          const userInfo = await getUserInfo();
          if (userInfo) {
            this.userId = userInfo.id;
            this.userUuid = userInfo.uuid;
            this.user = {
              first_name: userInfo.first_name,
              last_name_initial: (userInfo.last_name || '').charAt(0),
              email: userInfo.email
            };
            this.shell.questionForm.name = userInfo.first_name;
            this.shell.questionForm.email = userInfo.email;
          }
        } catch (error) {
          console.error('Failed to fetch user info', error);
        } finally {
          this.isLoadingUser = false;
          document.body.classList.remove('loading-user');
          void this.loadInteractiveRiceProgress();
        }
      }, 300);
    } else {
      document.body.classList.remove('loading-user');
      this.isLoadingUser = false;
      this.interactiveWonRiceList = [];
      this.interactiveWonRiceChainAccess = 'available';
    }
    window.addEventListener('scroll', this.handleScrollThrottled, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });
    document.querySelectorAll(".guaranteed-card").forEach(card => {
      card.addEventListener("click", () => {
        if (card.classList.contains("active")) {
          card.classList.remove("active");
        } else {
          document.querySelectorAll(".guaranteed-card").forEach(el => el.classList.remove("active"));
          card.classList.add("active");
        }
      });
    });
    
    // Обработка хеша при загрузке страницы (для переходов с других страниц)
    this.handleHashScroll();
  },
  watch: {
    '$route'(to) {
      if (to.path === '/') {
        void this.loadInteractiveRiceProgress();
      }
      // Обрабатываем хеш при изменении роута (например, переход с другой страницы)
      if (to.path === '/' && (to.hash || window.location.hash)) {
        // Дожидаемся полной загрузки страницы
        this.$nextTick(() => {
          // Дополнительная задержка для полной загрузки DOM
          setTimeout(() => {
            this.handleHashScroll();
          }, 300);
        });
      }
    },
    /** Смена «мало записей» ↔ скролл: OverlayScrollbars пересоздаётся по resize (см. osScrollbar). */
    winnersListFewNoScrollbar(isFew) {
      if (isFew) {
        this.teardownWinnersScrollTarget();
      }
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
        if (!isFew) {
          this.setupWinnersScrollTarget();
        }
      });
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScrollThrottled);
    window.removeEventListener('resize', this.handleResize);
    if (this.sectionsStickyResizeObserver) {
      this.sectionsStickyResizeObserver.disconnect();
      this.sectionsStickyResizeObserver = null;
    }
    this.disableHowPageLock();
    if (this._handleScrollRafId) {
      cancelAnimationFrame(this._handleScrollRafId);
      this._handleScrollRafId = null;
    }

    this.teardownWinnersScrollTarget();
  },
  computed: {
    isPromoActionsDisabled() {
      return !state.promoStatusLoaded;
    },
    isUploadActionsDisabled() {
      return !state.promoStatusLoaded || state.isUploadOpened;
    },
    isTelegramPage() {
      return this.$route?.meta?.isTelegramPage === true;
    },
    telegramBotUrl() {
      return process.env.VUE_APP_TELEGRAM_BOT_URL || 'https://t.me/';
    },
    isTelegramAboutPage() {
      return this.$route?.meta?.telegramPageType === 'about';
    },
    isTelegramWinnersPage() {
      return this.$route?.meta?.telegramPageType === 'winners';
    },
    showHeroSection() {
      return !this.isTelegramWinnersPage;
    },
    showHowSection() {
      return !this.isTelegramWinnersPage;
    },
    showPrizesSection() {
      return !this.isTelegramWinnersPage;
    },
    showWinnersSection() {
      return !this.isTelegramAboutPage;
    },
    /** Без внутреннего скролла и полосы: десктоп ≤5 строк, мобилка как чеки в ЛК — <4. */
    winnersListFewNoScrollbar() {
      const n = this.winners.length;
      if (!n) return false;
      if (this.viewportWidth <= 767) {
        return n < 4;
      }
      return n <= 5;
    },
    winnersPeriodOptions() {
      const fromApi = (this.availablePeriods || [])
        .filter((p) => p && p.id !== undefined && p.id !== null && `${p.id}`.trim() !== '')
        .map((p) => ({
          id: p.id,
          label: p.label || 'Период',
        }));
      return [{ id: '', label: 'Весь период' }, ...fromApi];
    },
    showFaqSection() {
      return !this.isTelegramWinnersPage;
    },
    showFaqQuestion() {
      return !this.isTelegramAboutPage;
    },
    showWeeklySliderArrows() {
      return this.viewportWidth > 767 && this.availablePrizes.weekly.length > 3;
    },
    howSectionMobileStyle() {
      if (!this.isHowMobileView) {
        return {};
      }

      return {
        '--how-slides': this.howSlidesCount,
        '--how-slide-step': '120svh'
      };
    },
    sectionsStickyOuterStyle() {
      if (!this.isHowMobileView) {
        return {};
      }

      return {
        '--sections-sticky-inner-height': `${this.sectionsStickyInnerHeight || 0}px`
      };
    },
    grandPrize() {
      return this.availablePrizes.grand.length ? this.availablePrizes.grand[0] : null;
    },
    isMainPrizesMobile() {
      return this.viewportWidth <= 767;
    },
    mainPrizesIntroPagination() {
      return {
        el: '#main-prizes-intro-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet prizes-mobile-pbar__seg',
        bulletActiveClass: 'swiper-pagination-bullet-active prizes-mobile-pbar__seg--active',
      };
    },
    productsMobilePagination() {
      return {
        el: '#products-section-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet prizes-mobile-pbar__seg',
        bulletActiveClass: 'swiper-pagination-bullet-active prizes-mobile-pbar__seg--active',
      };
    },
    riceCards() {
      return this.riceProducts.length ? this.riceProducts : this.riceFallbackList;
    },
    interactiveWonRiceNormalized() {
      return normalizeWonRiceGamesListForUi(this.interactiveWonRiceList);
    },
    interactiveRiceWonCount() {
      if (!getToken()) return 0;
      return this.interactiveWonRiceNormalized.filter((g) => g.available === 'won').length;
    },
    interactiveRiceProgressLabel() {
      const n = this.interactiveRiceWonCount;
      return `${n}/6 казанов правильного плова`;
    },
    /**
     * Полоска казанов на главной — декоративный прогресс «N/6»: первые N иконок синие.
     * Не привязываем к индексу в массиве API (порядок строк won-rice может отличаться от 1→6).
     */
    interactiveKazanSlots() {
      const n = this.interactiveRiceWonCount;
      return Array.from({ length: 6 }, (_, si) => ({
        done: si < n,
      }));
    },
    productsMobileAutoplay() {
      if (!this.isMainPrizesMobile || this.riceCards.length < 2) {
        return false;
      }
      return {
        delay: 4200,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    },
    shopCards() {
      return this.shopProducts.length ? this.shopProducts : this.shopFallbackList;
    },
    storesMobilePagination() {
      return {
        el: '#stores-section-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet prizes-mobile-pbar__seg',
        bulletActiveClass: 'swiper-pagination-bullet-active prizes-mobile-pbar__seg--active',
      };
    },
    rulesUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/rules`;
    },
    policyUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/policy`;
    },
    agreementUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/agreement`;
    },
    advertisingUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/advertising`;
    },
    cookieUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/cookie`;
    },
    settingsUrl() {
      return `${process.env.VUE_APP_API_URL}/api/main/settings`;
    },
    promoRangeText() {
      return formatPromoRangeRu(this.mainSettings?.start_date, this.mainSettings?.end_date);
    },
    promoRangeTextWithYear() {
      return this.promoRangeText;
    },
    promoStartText() {
      const start = this.mainSettings?.start_date;
      if (!start) {
        return state.promoStart || '';
      }

      const startDate = new Date(start);
      if (Number.isNaN(startDate.getTime())) {
        return state.promoStart || '';
      }

      const formatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return `${formatter.format(startDate)} года`;
    },
    isQuestionFormValid() {
      if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
        return false;
      }
      if (!this.shell.questionForm.email || !this.isEmailStrictValid(this.shell.questionForm.email.trim())) {
        return false;
      }
      if (!this.shell.questionForm.subject || this.shell.questionForm.subject === 'Выберите тему') {
        return false;
      }
      const text = (this.shell.questionForm.text || '').trim();
      if (text.length < 2 || text.length > 600) {
        return false;
      }
      if (!this.shell.questionForm.agree_personal_data) {
        return false;
      }
      if (
        (this.shell.feedbackErrors.name && this.shell.feedbackErrors.name !== '') ||
        (this.shell.feedbackErrors.email && this.shell.feedbackErrors.email !== '') ||
        (this.shell.feedbackErrors.subject && this.shell.feedbackErrors.subject !== '') ||
        (this.shell.feedbackErrors.text && this.shell.feedbackErrors.text !== '') ||
        (this.shell.feedbackErrors.agree_personal_data && this.shell.feedbackErrors.agree_personal_data !== '')
      ) {
        return false;
      }
      return true;
    },
    isRegisterFormValid() {
      return (
        registerNameSignificantLength(this.shell.registerForm.first_name) >= 2 &&
        registerNameSignificantLength(this.shell.registerForm.last_name) >= 2 &&
        this.shell.registerForm.email.length > 0 &&
        this.isEmailStrictValid(this.shell.registerForm.email) &&
        isValidRussianMobilePhone(this.shell.registerForm.phone_number) &&
        this.shell.registerForm.agree_rules &&
        !this.shell.errors.first_name &&
        !this.shell.errors.last_name &&
        !this.shell.errors.email &&
        !this.shell.errors.phone_number
      );
    },
    isLoginFormValid() {
      const email = this.shell.email;
      const password = this.shell.password;
      
      if (!email || email.trim() === '') {
        return false;
      }
      
      // Строгая валидация email формата
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      
      if (!password || password.trim() === '') {
        return false;
      }

      if (password.length < 6) {
        return false;
      }
      
      // Проверяем, что нет ошибок валидации (пустая строка или undefined считаются отсутствием ошибки)
      return (!this.shell.loginFormErrors.email || this.shell.loginFormErrors.email === '') && 
             (!this.shell.loginFormErrors.password || this.shell.loginFormErrors.password === '');
    },
    isResetPasswordFormValid() {
      const email = this.shell.resetPasswordForm.email;
      if (!this.isEmailStrictValid(email)) {
        return false;
      }
      // Проверяем, что нет ошибки валидации (пустая строка или undefined считаются отсутствием ошибки)
      return !this.shell.resetPasswordErrors.email || this.shell.resetPasswordErrors.email === '';
    },
    formattedPhoneNumber() {
      // Убираем знак '+' и все нецифровые символы
      const cleaned = this.phoneNumber.replace(/\D/g, '');

      // Проверяем, что номер начинается с '7' и содержит 11 цифр
      if (cleaned.length === 11 && cleaned.startsWith('7')) {
        return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
      }

      return ' ';
    }
  },
  // mounted(){
    
  // },
  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth;
      this.isHowMobileView = window.innerWidth <= 767;
      this.updateSectionsStickyInnerHeight();
      this.$nextTick(() => {
        if (this.mainPrizesIntroSwiper && typeof this.mainPrizesIntroSwiper.update === 'function') {
          this.mainPrizesIntroSwiper.update();
        }
        if (this.productsMobileSwiper && typeof this.productsMobileSwiper.update === 'function') {
          this.productsMobileSwiper.update();
        }
        if (this.storesMobileSwiper && typeof this.storesMobileSwiper.update === 'function') {
          this.storesMobileSwiper.update();
        }
      });

      if (!this.isHowMobileView) {
        this.activeHowSlide = 0;
        this.isHowPinned = false;
        this.howSlideLockUntil = 0;
        if (this.howSwiper) {
          this.howSwiper.slideTo(0, 0);
        }
        this.disableHowPageLock();
        this.howWheelDeltaAcc = 0;
        this.howWheelDeltaDir = 0;
        this.howTouchDeltaAcc = 0;
        this.howTouchDeltaDir = 0;
      } else {
        this.updateHowScrollState();
      }
    },
    syncHowSwiperToActive(animate = false) {
      if (!this.howSwiper) {
        return;
      }
      const target = Math.min(this.howSlidesCount - 1, Math.max(0, this.activeHowSlide));
      if (this.howSwiper.activeIndex !== target) {
        this.howSwiper.slideTo(target, animate ? 280 : 0);
      }
    },
    onHowSwiperInit(swiper) {
      this.howSwiper = swiper;
      this.activeHowSlide = swiper?.activeIndex || 0;
    },
    onHowSwiperChange(swiper) {
      this.activeHowSlide = swiper?.activeIndex || 0;
      this.updateSectionsStickyInnerHeight();
    },
    onMainPrizesIntroSwiperInit(swiper) {
      this.mainPrizesIntroSwiper = swiper;
    },
    onMainPrizesIntroSlideChange(swiper) {
      this.mainPrizesIntroSwiper = swiper;
    },
    onProductsMobileSwiperInit(swiper) {
      this.productsMobileSwiper = swiper;
    },
    onProductsMobileSlideChange(swiper) {
      this.productsMobileSwiper = swiper;
    },
    onStoresMobileSwiperInit(swiper) {
      this.storesMobileSwiper = swiper;
    },
    onStoresMobileSlideChange(swiper) {
      this.storesMobileSwiper = swiper;
    },
    updateSectionsStickyInnerHeight() {
      this.$nextTick(() => {
        const inner = this.$refs.sectionsStickyInner;
        if (!inner) {
          this.sectionsStickyInnerHeight = 0;
          return;
        }
        this.sectionsStickyInnerHeight = Math.ceil(inner.offsetHeight || 0);
      });
    },
    scrollWeeklyPrizes(direction) {
      const viewport = this.$refs.weeklyPrizesViewport;
      if (!viewport) {
        return;
      }

      const step = this.getWeeklySliderStep(viewport);
      const currentIndex = Math.round(viewport.scrollLeft / step);
      const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      const maxIndex = this.getWeeklySliderMaxIndex(viewport, step);
      const clampedIndex = Math.max(0, Math.min(nextIndex, maxIndex));
      viewport.scrollTo({ left: clampedIndex * step, behavior: 'smooth' });
    },
    getWeeklySliderStep(viewport) {
      const items = viewport.querySelectorAll('.prizes-blocks-item');
      if (items.length > 1) {
        const step = items[1].offsetLeft - items[0].offsetLeft;
        if (step > 0) {
          return step;
        }
      }

      const firstItem = items[0];
      if (firstItem) {
        return firstItem.getBoundingClientRect().width;
      }

      return Math.max(1, viewport.clientWidth);
    },
    getWeeklySliderMaxIndex(viewport, step) {
      const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      return Math.max(0, Math.round(maxScrollLeft / step));
    },
    snapWeeklySliderToNearest(viewport) {
      const step = this.getWeeklySliderStep(viewport);
      const maxIndex = this.getWeeklySliderMaxIndex(viewport, step);
      const nearestIndex = Math.round(viewport.scrollLeft / step);
      const clampedIndex = Math.max(0, Math.min(nearestIndex, maxIndex));
      viewport.scrollTo({ left: clampedIndex * step, behavior: 'smooth' });
    },
    snapWeeklySliderAfterDrag(viewport) {
      const step = this.getWeeklySliderStep(viewport);
      const maxIndex = this.getWeeklySliderMaxIndex(viewport, step);
      const startIndex = Math.round(this.weeklySliderDragStartScrollLeft / step);
      const movedByPx = viewport.scrollLeft - this.weeklySliderDragStartScrollLeft;
      // Низкий порог, чтобы карточка перелистывалась при коротком движении мыши.
      const dragThreshold = Math.max(10, step * 0.06);

      let targetIndex = startIndex;
      if (Math.abs(movedByPx) >= dragThreshold) {
        targetIndex = movedByPx > 0 ? startIndex + 1 : startIndex - 1;
      } else {
        targetIndex = Math.round(viewport.scrollLeft / step);
      }

      const clampedIndex = Math.max(0, Math.min(targetIndex, maxIndex));
      viewport.scrollTo({ left: clampedIndex * step, behavior: 'smooth' });
    },
    onWeeklySliderWheel(event) {
      if (window.innerWidth <= 767) {
        return;
      }

      const viewport = this.$refs.weeklyPrizesViewport;
      if (!viewport) {
        return;
      }

      const delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
      if (Math.abs(delta) < 1) {
        return;
      }

      const direction = delta > 0 ? 1 : -1;
      const step = this.getWeeklySliderStep(viewport);
      const currentIndex = Math.round(viewport.scrollLeft / step);
      const maxIndex = this.getWeeklySliderMaxIndex(viewport, step);

      // На краях слайдера не перехватываем колесо — отдаем событие странице.
      if ((currentIndex <= 0 && direction < 0) || (currentIndex >= maxIndex && direction > 0)) {
        return;
      }

      event.preventDefault();

      if (this.weeklyWheelLock) {
        return;
      }

      const targetIndex = Math.max(0, Math.min(currentIndex + direction, maxIndex));

      this.weeklyWheelLock = true;
      if (this.weeklyWheelUnlockTimer) {
        clearTimeout(this.weeklyWheelUnlockTimer);
      }
      this.weeklyWheelUnlockTimer = setTimeout(() => {
        this.weeklyWheelLock = false;
      }, 380);

      viewport.scrollTo({ left: targetIndex * step, behavior: 'smooth' });
    },
    onWeeklySliderPointerDown(event) {
      if (window.innerWidth <= 767) {
        return;
      }
      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }
      const viewport = this.$refs.weeklyPrizesViewport;
      if (!viewport) {
        return;
      }

      this.isWeeklySliderDragging = true;
      this.weeklySliderPointerId = event.pointerId;
      this.weeklySliderDragStartX = event.clientX;
      this.weeklySliderDragStartScrollLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');

      if (typeof viewport.setPointerCapture === 'function') {
        viewport.setPointerCapture(event.pointerId);
      }
    },
    onWeeklySliderPointerMove(event) {
      if (window.innerWidth <= 767) {
        return;
      }
      if (!this.isWeeklySliderDragging || this.weeklySliderPointerId !== event.pointerId) {
        return;
      }
      const viewport = this.$refs.weeklyPrizesViewport;
      if (!viewport) {
        return;
      }

      const deltaX = event.clientX - this.weeklySliderDragStartX;
      // Чуть увеличиваем чувствительность drag, чтобы не нужно было "тянуть" далеко.
      viewport.scrollLeft = this.weeklySliderDragStartScrollLeft - (deltaX * 1.35);
      event.preventDefault();
    },
    onWeeklySliderPointerUp(event) {
      if (window.innerWidth <= 767) {
        this.isWeeklySliderDragging = false;
        this.weeklySliderPointerId = null;
        return;
      }
      if (this.weeklySliderPointerId !== null && event.pointerId !== this.weeklySliderPointerId) {
        return;
      }
      const viewport = this.$refs.weeklyPrizesViewport;
      if (viewport) {
        viewport.classList.remove('is-dragging');
        if (typeof viewport.releasePointerCapture === 'function' && this.weeklySliderPointerId !== null) {
          try {
            viewport.releasePointerCapture(this.weeklySliderPointerId);
          } catch (e) {
            // no-op
          }
        }
      }

      this.isWeeklySliderDragging = false;
      this.weeklySliderPointerId = null;
      if (viewport) {
        this.snapWeeklySliderAfterDrag(viewport);
      }
    },
    isEmailStrictValid(email) {
      const normalized = String(email || '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim();
      if (!normalized) {
        return false;
      }
      // Строгая проверка формата:
      // - основная часть начинается с буквы/цифры
      // - домен начинается с буквы/цифры
      // - допустимы только стандартные символы email
      const strictRegex = /^[A-Za-z0-9][A-Za-z0-9._%+-]*@[A-Za-z0-9][A-Za-z0-9.-]*\.[A-Za-z]{2,}$/;
      return strictRegex.test(normalized);
    },
    getFirstError(errorsObj) {
      if (!errorsObj || typeof errorsObj !== 'object') return '';
      const firstError = Object.values(errorsObj).find((value) => {
        if (typeof value === 'string') return value.trim() !== '';
        return Boolean(value);
      });
      return typeof firstError === 'string' ? firstError : '';
    },
    formatPeriodDate(dateStr) {
      if (!dateStr) return '';

      // Преобразуем строку даты в объект Date
      const date = new Date(dateStr);

      // Форматируем дату для русской локали
      return date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long'
      });
    },
    applyFilters() {
      this.loadWinners(true);
    },
    validateField(field) {
      switch (field) {
        case 'first_name': {
          this.shell.errors.first_name =
            registerNameSignificantLength(this.shell.registerForm.first_name) < 2
              ? 'Введите имя (минимум 2 символа)'
              : '';
          break;
        }
        case 'name': {
          if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
            this.shell.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
          } else {
            this.shell.feedbackErrors.name = '';
          }
          break;
        }
        case 'text': {
          this.shell.feedbackErrors.text = this.shell.questionForm.text.length < 2 ? 'Поле обязательно для заполнения' : '';
          break;
        }
        case 'last_name': {
          this.shell.errors.last_name =
            registerNameSignificantLength(this.shell.registerForm.last_name) < 2
              ? 'Введите фамилию (минимум 2 символа)'
              : '';
          break;
        }
        case 'email': {
          const email = this.shell.registerForm.email;
          if (!email || email.trim() === '') {
            this.shell.errors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.shell.errors.email = 'Введите корректный email';
          } else {
            this.shell.errors.email = '';
          }
          break;
        }
        case 'email_login': {
          const email = this.shell.email;
          this.shell.loginFormErrors.email = this.isEmailStrictValid(email) ? '' : 'Поле обязательно для заполнения';
          break;
        }
        case 'email_feedback': {
          const email = this.shell.questionForm.email;
          if (!email || email.trim() === '') {
            this.shell.feedbackErrors.email = 'Поле обязательно для заполнения';
          } else if (!this.isEmailStrictValid(email)) {
            this.shell.feedbackErrors.email = 'Введите корректный email';
          } else {
            this.shell.feedbackErrors.email = '';
          }
          break;
        }
        case 'phone_number': {
          this.shell.registerPhoneTouched = true;
          const raw = this.shell.registerForm.phone_number;
          const d = String(raw || '').replace(/\D/g, '');

          if (d.length === 0) {
            this.shell.errors.phone_number = 'Поле обязательно для заполнения';
            break;
          }
          if (isValidRussianMobilePhone(raw)) {
            this.shell.errors.phone_number = '';
            break;
          }
          this.shell.errors.phone_number = russianMobilePhoneHint();
          break;
        }
        case 'agree_rules': {
          this.shell.errors.agree_rules = !this.shell.registerForm.agree_rules ? 'Необходимо согласиться с правилами акции' : '';
          break;
        }
      }
    },
    async fetchPrizes() {
      try {
        const response = await getPrizes({
          available_only: true,
          limit: 100
        });
        const results = Array.isArray(response) ? response : (response?.results || []);
        const normalized = results.map((prize) => ({
          ...prize,
          type: this.normalizePrizeType(prize.type)
        }));

        this.availablePrizes = {
          grand: normalized.filter((p) => p.type === 'grand'),
          weekly: normalized.filter((p) => p.type === 'weekly'),
          guaranteed: normalized.filter((p) => p.type === 'guaranteed'),
          special: normalized.filter((p) => p.type === 'special')
        };
      } catch (error) {
        console.error('Failed to fetch prizes:', error);
      }
    },
    normalizePrizeType(type) {
      if (type === 'daily') {
        return 'weekly';
      }

      return type;
    },
    getPrizeImage(prize) {
      if (!prize || !Array.isArray(prize.images) || !prize.images.length) {
        return '';
      }

      const firstImage = prize.images[0];
      const rawUrl = typeof firstImage === 'string'
        ? firstImage
        : (firstImage?.url || firstImage?.image || firstImage?.file || firstImage?.src || '');

      if (!rawUrl) {
        return '';
      }

      if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
        return rawUrl;
      }

      if (rawUrl.startsWith('/')) {
        return `${process.env.VUE_APP_API_URL}${rawUrl}`;
      }

      return rawUrl;
    },
    riceImageSrc(image) {
      if (image === undefined || image === null || image === '') {
        return '';
      }
      if (typeof image !== 'string') {
        return String(image);
      }
      const s = image.trim();
      if (!s) {
        return '';
      }
      if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('//')) {
        return s;
      }
      if (s.startsWith('/')) {
        return `${process.env.VUE_APP_API_URL || ''}${s}`;
      }
      return s;
    },
    riceCardStyle(background) {
      if (background === undefined || background === null) {
        return {};
      }
      const s = String(background).trim();
      if (!s) {
        return {};
      }
      if (s.startsWith('url(')) {
        return { background: s };
      }
      if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
        return {
          backgroundImage: `url("${s}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        };
      }
      if (s.startsWith('/')) {
        const base = process.env.VUE_APP_API_URL || '';
        return {
          backgroundImage: `url("${base}${s}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        };
      }
      return {
        background: s,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    },
    normalizeRiceList(payload) {
      let raw = [];
      if (Array.isArray(payload)) {
        raw = payload;
      } else if (payload && Array.isArray(payload.results)) {
        raw = payload.results;
      } else if (payload && Array.isArray(payload.items)) {
        raw = payload.items;
      } else if (payload && Array.isArray(payload.data)) {
        raw = payload.data;
      }
      return raw
        .map((item, index) => ({
          id: item.id ?? item.slug ?? `rice-${index}`,
          rice_type: item.rice_type ?? item.riceType ?? '',
          title: item.title ?? '',
          background: item.background ?? '',
          image: item.image ?? item.image_url ?? item.imageUrl ?? '',
        }))
        .filter((row) => row.image || row.title || row.rice_type);
    },
    async loadRiceProducts() {
      try {
        const payload = await fetchRiceProducts();
        const list = this.normalizeRiceList(payload);
        if (list.length) {
          this.riceProducts = list;
          this.$nextTick(() => {
            if (this.productsMobileSwiper && typeof this.productsMobileSwiper.update === 'function') {
              this.productsMobileSwiper.update();
            }
          });
        }
      } catch (e) {
        console.error('Failed to load rice products', e);
      }
    },
    resolveShopUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }
      const s = url.trim();
      if (!s || s === '#') {
        return '';
      }
      if (s.startsWith('http://') || s.startsWith('https://')) {
        return s;
      }
      if (s.startsWith('//')) {
        return `https:${s}`;
      }
      if (s.startsWith('/')) {
        return `${process.env.VUE_APP_API_URL || ''}${s}`;
      }
      if (/^[\w.-]+\.[a-z]{2,}(\/|$)/i.test(s)) {
        return `https://${s}`;
      }
      return s;
    },
    shopHref(url) {
      return this.resolveShopUrl(url) || '#';
    },
    shopHasExternalUrl(url) {
      return Boolean(this.resolveShopUrl(url));
    },
    onShopLinkClick(event, url) {
      this.trackStoreClick();
      if (!this.resolveShopUrl(url)) {
        event.preventDefault();
      }
    },
    shopImageSrc(image) {
      return this.riceImageSrc(image);
    },
    normalizeShopsList(payload) {
      let raw = [];
      if (Array.isArray(payload)) {
        raw = payload;
      } else if (payload && Array.isArray(payload.results)) {
        raw = payload.results;
      } else if (payload && Array.isArray(payload.items)) {
        raw = payload.items;
      } else if (payload && Array.isArray(payload.data)) {
        raw = payload.data;
      }
      return raw
        .map((item, index) => ({
          id: item.id ?? item.slug ?? `shop-${index}`,
          image: item.image ?? item.logo ?? item.logo_url ?? '',
          url: item.url ?? item.link ?? '',
        }))
        .filter((row) => row.image || this.resolveShopUrl(row.url));
    },
    async loadShops() {
      try {
        const payload = await fetchShops();
        const list = this.normalizeShopsList(payload);
        if (list.length) {
          this.shopProducts = list;
          this.$nextTick(() => {
            if (this.storesMobileSwiper && typeof this.storesMobileSwiper.update === 'function') {
              this.storesMobileSwiper.update();
            }
          });
        }
      } catch (e) {
        console.error('Failed to load shops', e);
      }
    },
    isRomanticPrize(prize) {
      return Number(prize?.id) === 7;
    },
    selectPrize(option) {
      this.prizeType = option.value; // Устанавливаем prizeType
      this.selectValue = option.label; // Меняем текст в кнопке
      this.isOpenSelect = false; // Закрываем список
      this.loadWinners(true); // Загружаем список победителей
    },
    handleDynamicButtonClick(event) {
      if (event.target.id === 'apm-close-widget-button') {
        this.$sendMetrik('reachGoal', 'upload_check_closed');
        state.isUploadOpened = false;
        document.body.classList.remove('is-upload-widget-opened');
      }
    },
    /** Список победителей: после полной загрузки страницы (`load`), чтобы не конкурировать с критичными ресурсами и соответствовать ожиданию «данные после загрузки». */
    scheduleWinnersDeferredLoad() {
      if (!this.showWinnersSection) {
        return;
      }
      if (typeof window === 'undefined') {
        return;
      }
      const run = () => {
        void this.initWinnersBlockDeferred();
      };
      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run, { once: true });
      }
    },
    async initWinnersBlockDeferred() {
      if (!this.showWinnersSection) {
        return;
      }
      try {
        await this.loadWinnersPeriodsFromApi();
      } catch (e) {
        console.error('Winners periods load failed', e);
      }
      await this.loadWinners(true);
    },
    retryLoadWinners() {
      this.winnersFetchError = false;
      this.loadWinners(true);
    },
    async loadWinners(reset = false) {
      if (this.loading) return;
      this.loading = true;

      if (reset) {
        this.winnersFetchError = false;
        this.teardownWinnersScrollTarget();
        this.offset = 0;
        this.winners = [];
        this.hasMoreWinners = true;
        this.noWinners = false;
      }

      try {
        const hasPeriodFilter =
          this.selectedPeriod !== '' &&
          this.selectedPeriod !== null &&
          this.selectedPeriod !== undefined;

        let periodParam = null;
        if (hasPeriodFilter) {
          const n = Number(this.selectedPeriod);
          periodParam = Number.isFinite(n) ? n : null;
        }

        /* Периоды в API относятся к еженедельным победителям — всегда prize_type=weekly при фильтре по периоду. */
        const prizeTypeForApi = hasPeriodFilter ? 'weekly' : this.winnersPrizeType;

        const params = {
          limit: this.limit,
          offset: this.offset,
          prize_type: prizeTypeForApi,
          period: periodParam,
        };

        if (this.winnersSearchEmail && this.winnersSearchEmail.trim()) {
          params.search = this.winnersSearchEmail.trim();
        }

        const data = await fetchWinnings(params);
        const newWinners = Array.isArray(data?.results) ? data.results : [];

        const merged = reset ? newWinners : [...this.winners, ...newWinners];
        this.winners = this.sortWinnersByDateDesc(merged);
        this.totalCount = Number(data?.count || 0);
        this.offset += newWinners.length;
        // Защита от кривого next: считаем, что "есть ещё", только если offset < count
        this.hasMoreWinners = this.offset < this.totalCount && Boolean(data?.next);
        this.noWinners = this.winners.length === 0;
        this.winnersFetchError = false;
      } catch (error) {
        console.error('Error loading winners:', error);
        if (reset || !this.winners.length) {
          this.winnersFetchError = true;
          this.noWinners = false;
        }
        this.hasMoreWinners = false;
      } finally {
        this.loading = false;

        // После первой успешной загрузки инициализируем "правильный" скролл-таргет
        // для победителей (учитывая, что OverlayScrollbars может обернуть контейнер).
        this.$nextTick(() => {
          const host = this.$refs.winnersList;
          const scrollTargetEarly = host
            ? (host.__osInstance?.elements?.().viewport || host.querySelector('[data-overlayscrollbars-viewport]') || host)
            : null;
          if (reset && scrollTargetEarly) {
            scrollTargetEarly.scrollTop = 0;
          }

          this.setupWinnersScrollTarget();
        });
      }
    },

    async loadWinnersPeriodsFromApi() {
      if (!this.showWinnersSection) {
        return;
      }
      const mapPeriodRow = (item, i) => {
        const id =
          item?.id ??
          item?.period ??
          item?.code ??
          (item?.start_at ? new Date(item.start_at).toISOString().slice(0, 7) : null);
        const label =
          item?.label ||
          item?.title ||
          (item && typeof item === 'object' ? this.formatPeriodForSelect(item) : String(item));
        const safeId = id != null && String(id).trim() !== '' ? id : `period-${i}`;
        return { id: safeId, label: label || 'Период', raw: item };
      };

      try {
        const data = await fetchQuizPeriods();
        const raw = Array.isArray(data) ? data : [];
        this.availablePeriods = raw.map((item) => ({
          id: item.id,
          label: item.title || this.formatPeriodForSelect(item),
          raw: item,
        }));
      } catch (e) {
        console.warn('fetchQuizPeriods failed, falling back to periods-with-winnings', e);
        try {
          const data = await fetchWinningPeriods({ limit: 100, offset: 0 });
          const raw = Array.isArray(data) ? data : (data?.results || data?.periods || data?.items || []);
          this.availablePeriods = raw.map(mapPeriodRow);
        } catch (e2) {
          console.error('Failed to load winning periods', e2);
          this.availablePeriods = [];
        }
      }
    },

    sortWinnersByDateDesc(rows) {
      if (!Array.isArray(rows) || rows.length < 2) {
        return rows || [];
      }
      const ts = (w) => {
        const raw =
          w?.draw_date ||
          w?.draw_at ||
          w?.created_at ||
          w?.date ||
          w?.period_end ||
          w?.period?.end_at ||
          w?.winner?.created_at ||
          w?.raw?.draw_date;
        if (!raw) {
          return 0;
        }
        const n = new Date(raw).getTime();
        return Number.isFinite(n) ? n : 0;
      };
      return [...rows].sort((a, b) => ts(b) - ts(a));
    },

    teardownWinnersScrollTarget() {
      if (this._winnersScrollTarget) {
        this._winnersScrollTarget.removeEventListener('scroll', this.handleWinnersScroll);
        this._winnersScrollTarget = null;
        this._winnersScrollTargetInitialized = false;
      }
    },

    setupWinnersScrollTarget() {
      this.$nextTick(() => {
        if (this.winnersListFewNoScrollbar) return;
        if (this._winnersScrollTargetInitialized) return;
        const host = this.$refs.winnersList;
        if (!host) return;

        const instance = host.__osInstance;
        const viewport =
          instance && instance.elements ? instance.elements().viewport : host.querySelector('[data-overlayscrollbars-viewport]');
        const scrollTarget = viewport || host;

        this._winnersScrollTarget = scrollTarget;
        this._winnersScrollTargetInitialized = true;
        scrollTarget.addEventListener('scroll', this.handleWinnersScroll, { passive: true });
      });
    },

    handleWinnersScroll() {
      if (!this.hasMoreWinners || this.loading) {
        return;
      }

      const target = this._winnersScrollTarget || this.$refs.winnersList;
      if (!target) return;

      const scrollBottom = target.scrollTop + target.clientHeight;
      const triggerOffset = target.scrollHeight - 80;
      if (scrollBottom >= triggerOffset) {
        this.loadWinners();
      }
    },

    // Фолбэк для случаев, когда список победителей не имеет собственного скролла
    // и прокручивается вся страница: подгружаем ещё, когда низ блока близко к низу окна.
    handleWindowScrollForWinners() {
      if (!this.hasMoreWinners || this.loading) {
        return;
      }

      const container = this.$refs.winnersList;
      if (!container) {
        return;
      }

      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const triggerOffset = 80;

      if (rect.bottom - triggerOffset <= viewportHeight) {
        this.loadWinners();
      }
    },

    handleWinnersSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.loadWinners(true);
      }, 500);
    },
    
    setWinnersPrizeType(type) {
      this.isWinnersPeriodOpen = false;
      if (type !== 'weekly') {
        this.selectedPeriod = '';
        this.selectedPeriodText = 'Весь период';
      }
      this.winnersPrizeType = type;
      this.loadWinners(true);
    },
    
    handlePeriodChange() {
      this.loadWinners(true);
    },

    getWinnerItemKey(winner, index) {
      if (winner && winner.id) {
        return winner.id;
      }
      const email = winner && winner.winner && winner.winner.email ? winner.winner.email : '';
      const prizeId = winner && winner.prize && winner.prize.id ? winner.prize.id : '';
      return `${email}-${prizeId}-${index}`;
    },
    getWinnerDisplayName(winner) {
      const winnerData = winner && winner.winner ? winner.winner : winner;
      return this.formatWinnerName(winnerData);
    },
    getWinnerDisplayEmail(winner) {
      const winnerData = winner && winner.winner ? winner.winner : winner;
      return this.getWinnerEmail(winnerData);
    },
    getWinnerPrizeText(winner) {
      return this.formatPrizeText(winner && winner.prize ? winner.prize : {});
    },

    // Методы форматирования
    formatWinnerDate(date) {
      const d = new Date(date);
      return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
    },
    
    formatWinnerName(winnerData) {
      // Бэкенд уже возвращает готовое отображаемое имя победителя,
      // поэтому просто отдаём его как есть, без обрезки/маскировки
      return winnerData && winnerData.name ? winnerData.name : 'Не указано';
    },
    
    getWinnerEmail(winnerData) {
      // Бэкенд тоже отдаёт уже подготовленное значение email (в т.ч. с маскировкой),
      // поэтому не изменяем его на фронте.
      if (winnerData && winnerData.email) {
        return winnerData.email;
      }
      const winner = winnerData && winnerData.winner;
      if (winner && typeof winner === 'object' && winner.email) {
        return winner.email;
      }
      return 'Email не указан';
    },
    
    formatPrizeText(prize) {
      // Поддерживаем оба формата:
      // 1) Новый: prize — уже готовая строка с бэка
      // 2) Объект: в блоке «Победители» показываем title (напр. «10000 р»); greeting_text — для подсказок в карточках призов, не для плашки
      if (typeof prize === 'string') {
        return this.normalizeBackendText(prize);
      }
      if (prize && prize.title) {
        return this.normalizeBackendText(prize.title);
      }
      if (prize && prize.greeting_text) {
        return this.normalizeBackendText(prize.greeting_text);
      }
      return this.normalizeBackendText('Приз не указан');
    },
    
    formatPeriodForSelect(period) {
      if (!period || typeof period !== 'object') {
        return period ? String(period) : 'Период';
      }
      // Форматируем период для dropdown: "Февраль 2026" или "Март 2026"
      if (period.start_at) {
        const start = new Date(period.start_at);
        const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
          'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        const monthName = monthNames[start.getMonth()];
        const year = start.getFullYear();
        
        // Фильтруем только Февраль 2026 и Март 2026
        if ((monthName === 'Февраль' || monthName === 'Март') && year === 2026) {
          return `${monthName} ${year}`;
        }
        
        // Для других месяцев тоже показываем, но фильтруем в availablePeriods
        return `${monthName} ${year}`;
      }
      // Если нет start_at, используем title
      return period.title || 'Период';
    },
    
    // Форматирование значения главного приза (извлекаем сумму из title)
    formatPrizeValue(prize) {
      if (!prize.title) return '';
      
      // Ищем сумму в названии (например, "Путешествие на 600000 руб" -> "600 000 ₽")
      // Ищем числа с пробелами или без (600000, 600 000, 4 000 и т.д.)
      const match = prize.title.match(/([\d\s]+)\s*(?:руб|₽|рублей|руб\.)/i);
      if (match) {
        // Убираем пробелы из числа и форматируем
        const amount = parseInt(match[1].replace(/\s/g, ''));
        if (!isNaN(amount)) {
          return `${amount.toLocaleString('ru-RU')} ₽`;
        }
      }
      
      // Если сумма не найдена, пытаемся извлечь из greeting_text
      if (prize.greeting_text) {
        const greetingMatch = prize.greeting_text.match(/([\d\s]+)\s*(?:руб|₽|рублей|руб\.)/i);
        if (greetingMatch) {
          const amount = parseInt(greetingMatch[1].replace(/\s/g, ''));
          if (!isNaN(amount)) {
            return `${amount.toLocaleString('ru-RU')} ₽`;
          }
        }
      }
      
      // Если ничего не найдено, возвращаем пустую строку
      return '';
    },
    
    // Форматирование описания главного приза
    formatPrizeDescription(prize) {
      if (prize.description) {
        return prize.description;
      }
      
      // Извлекаем описание из title (например, "на путешествие")
      if (prize.title) {
        // Убираем сумму и оставляем описание
        const withoutAmount = prize.title.replace(/\d+\s*(?:руб|₽|рублей)/gi, '').trim();
        if (withoutAmount && withoutAmount !== prize.title) {
          return withoutAmount;
        }
        
        // Если title содержит "на", извлекаем часть после "на"
        const onMatch = prize.title.match(/на\s+(.+)/i);
        if (onMatch) {
          return `на ${onMatch[1]}`;
        }
      }
      
      return '';
    },
    
    changeValueSelect(optionVal)  {
      this.selectValue = optionVal;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.toggleBodyScroll();
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.toggleBodyScroll();
    },
    toggleBodyScroll() {
      setMobileMenuScrollLock(this.isMenuOpen);
    },
    async fetchTopics() {
      try {
        this.shell.topics = await getFeedbackTopics();
      } catch (error) {
        console.error('Error loading topics:', error);
      }
    },
    isOpenGuarantedPopap(){
    },
    toggleDropdown() {
      this.clearFeedbackError('subject');
      this.shell.isOpen = !this.shell.isOpen;
      this.$nextTick(() => {
        if (this.$refs.dropDownBtn && this.$refs.dropDownList) {
          this.$refs.dropDownList.style.top = `${this.$refs.dropDownBtn.offsetHeight}px`;
        }
      });
    },
    selectItem(item) {
      this.shell.feedbackErrors.subject = null;
      this.shell.selectedText = item.title;
      this.shell.questionForm.subject = item.id;
      this.shell.isOpen = false;
      this.shell.isChange = true;
    },
    toggleWinnersPeriodDropdown() {
      this.isWinnersPeriodOpen = !this.isWinnersPeriodOpen;
    },
    selectWinnersPeriod(period) {
      if (!period || period.id === '' || period.id === undefined || period.id === null) {
        this.selectedPeriod = '';
        this.selectedPeriodText = 'Весь период';
        this.isWinnersPeriodChanged = false;
      } else {
        const id = period.id;
        const n = typeof id === 'number' ? id : Number(id);
        this.selectedPeriod = Number.isFinite(n) ? n : id;
        this.selectedPeriodText = period.label || 'Период';
        this.isWinnersPeriodChanged = true;
        this.winnersPrizeType = 'weekly';
      }
      this.isWinnersPeriodOpen = false;
      this.handlePeriodChange();
    },
    handleClickOutside(event) {
      // Проверяем, что this.$refs.dropdown существует
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.shell.isOpen = false;
      }
      if (this.$refs.winnersDropdown && !this.$refs.winnersDropdown.contains(event.target)) {
        this.isWinnersPeriodOpen = false;
      }
    },
    handleKeydown(event) {
      if (event.key === 'Tab' || event.key === 'Escape') {
        this.shell.isOpen = false;
        this.isWinnersPeriodOpen = false;
        if (event.key === 'Escape' && this.showAccountInteractivePopup) {
          this.closeAccountInteractivePopup();
        }
      }
    },
    getClientId() {
      // Проверяем согласие перед получением clientId
      if (!hasCookieConsent()) {
        return;
      }
      if (ANALYTICS_DISABLED) {
        return;
      }
      
      if (typeof ym !== 'undefined') {
        ym(YANDEX_METRIKA_COUNTER_ID, 'getClientID', (clientId) => {
          this.clientId = clientId;
          this.getUTMParams();
        });
      } else {
        console.error('Yandex.Metrica не доступна');
      }
    },
    addIntersectionObserver() {
      const options = {
        root: null, // используется viewport
        threshold: 0.10, // элемент должен быть виден на 25%
      };

      const observer = new IntersectionObserver(this.handleIntersection, options);

      // Находим все элементы с классом .js-animate-section
      const sections = document.querySelectorAll('.js-animate-section');

      // Наблюдаем за каждым элементом
      sections.forEach(section => {
        observer.observe(section);
      });
    },
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
        }
      });
    },
    initScrollAnimations() {
      if (document.documentElement.classList.contains('performance-lite')) {
        this.$nextTick(() => {
          const animatedElements = document.querySelectorAll('[data-animate]');
          animatedElements.forEach(el => {
            const animationType = el.getAttribute('data-animate');
            el.classList.add('animate-on-scroll', `animate-${animationType}`, 'is-animated');
          });
        });
        return;
      }
      // Инициализируем анимации при скролле
      this.$nextTick(() => {
        const observerOptions = {
          root: null,
          rootMargin: '0px 0px 200px 0px',
          threshold: 0.01
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-animated');
              // Отключаем наблюдение после анимации (once: true)
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        // Находим все элементы с атрибутом data-animate
        const animatedElements = document.querySelectorAll('[data-animate]');
        animatedElements.forEach(el => {
          const animationType = el.getAttribute('data-animate');
          const delay = el.getAttribute('data-animate-delay') || '0';
          
          el.classList.add('animate-on-scroll', `animate-${animationType}`);
          
          // Устанавливаем задержку
          if (delay !== '0') {
            const delayNum = parseInt(delay, 10);
            // Если задержка в стандартных значениях (100, 200, 300, 400, 500), используем класс
            if ([100, 200, 300, 400, 500].includes(delayNum)) {
              el.classList.add(`animate-delay-${delay}`);
            } else {
              // Для других значений используем inline style
              el.style.transitionDelay = `${delayNum / 1000}s`;
            }
          }
          
          observer.observe(el);
        });
      });
    },
    getUTMParams() {
      const params = new URLSearchParams(window.location.search);
      const utmParams = {
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        utm_term: params.get('utm_term'),
        utm_content: params.get('utm_content'),
        click_id: params.get('click_id')
      };

      // Фильтрация null значений
      const filteredParams = Object.fromEntries(
          Object.entries(utmParams).filter(([, value]) => value !== null)
      );

      // Если есть UTM параметры, сохраняем их в localStorage
      if (Object.keys(filteredParams).length > 0) {
        const paramsString = new URLSearchParams(filteredParams).toString();
        localStorage.setItem('registration_params', paramsString);
        this.utmParams = filteredParams;
      } else {
        // Если нет параметров в URL, пытаемся загрузить из localStorage
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          const savedParamsObj = Object.fromEntries(new URLSearchParams(savedParams));
          this.utmParams = savedParamsObj;
        } else {
          this.utmParams = {};
        }
      }

      // Добавляем clientId в utmParams после его получения
      if (this.clientId) {
        this.utmParams.client_id = this.clientId;
      }
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);

      this.shell.responseError = '';

      // Фильтрация по разрешённым типам файлов и размеру
      const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
      let hasOversize = false;

      const validFiles = files.filter(file => {
        const isValidType = /\.(jpg|jpeg|png|gif|tiff|webp|pdf)$/i.test(file.name);
        const isValidSize = file.size <= MAX_SIZE;
        if (!isValidSize) {
          hasOversize = true;
        }
        return isValidType && isValidSize;
      });

      if (hasOversize) {
        this.shell.responseError = 'Максимальный размер: 5MB';
      }

      const MAX_FEEDBACK_FILES = 10;
      const slotsLeft = Math.max(0, MAX_FEEDBACK_FILES - this.shell.filePreviews.length);
      if (slotsLeft === 0) {
        this.shell.responseError = 'Прикреплено максимальное количество файлов';
        event.target.value = '';
        return;
      }
      const filesToAdd =
        validFiles.length > slotsLeft ? validFiles.slice(0, slotsLeft) : validFiles;

      // Добавляем файлы в состояние и показываем их превью
      filesToAdd.forEach(file => {
        const preview = {
          file,
          name: file.name,
          type: file.type,
          preview: URL.createObjectURL(file) // для изображений
        };
        this.shell.filePreviews.push(preview);
        this.shell.questionForm.files.push(file);
      });
      event.target.value = '';
    },

    // Удаление файла
    removeFile(index) {
      // Удаляем файл из массива файлов
      this.shell.filePreviews.splice(index, 1);
      this.shell.questionForm.files.splice(index, 1);
    },
    handleRulesButtonClick() {
      // this.executeAdriverEvent('rules_click');
      this.$sendMetrik('reachGoal', 'Rules_Click');
    },
    addBodyClass() {
      document.body.classList.add('is-popup-opened');
    },
    removeBodyClass() {
      document.body.classList.remove('is-popup-opened');
    },
    async logout() {
      state.checkSoon = false;
      state.checksTotal = 0;
      state.checks = {
        count: 0,
        next: null,
        previous: null,
        results: [],
      };
      state.user = {
        address: {
          apartment: null,
          city: null,
          email: null,
          fio: null,
          house: null,
          phone_number: null,
          street: null,
          zip_code: null,
        },

        first_name: null,
        last_name: null,
        phone_number: null,
        email: null,
        gender: null,
        is_verification: null,
        birthday: null,
        id: null,
        uuid: null,
        is_possible_to_upload_receipt: null,
        address_is_filled: null,
        promocode: null,
        referral_id: null,
        referral_link: null,
        balance: null,
        privilege_level: null,
        need_points: null,
        checks_count: 0,
        approved_checks_count: 0,
        rejected_checks_count: 0,
        all_cash: 0
      };
      const widget = document.getElementById('apm-widget');
      if (widget) {
        widget.innerHTML = ''; // Очистка содержимого виджета
      }

      // Удаление токена
      removeToken();
      
      // Очистка всех форм
      this.shell.questionForm = {
        name: '',
        email: '',
        text: '',
        agree_personal_data: false,
        agree_to_advertising: false,
        subject: '',
        files: []
      };
      this.shell.filePreviews = [];
      this.shell.email = '';
      this.shell.password = '';
      this.shell.loginFormErrors = {};
      this.shell.feedbackErrors = {};
      this.shell.resetPasswordErrors = {};
      this.shell.errors = {};
      this.shell.responseError = '';
      
      // Обновление состояния пользователя
      this.user = null;
      this.toggleMobileNav(); // Закрытие мобильного меню
      
      // Ожидание завершения обновления DOM
      await this.$nextTick();

      // Выполняем перенаправление на главную
      if (this.$route.path !== '/') {
        this.$router.push('/');
      } else {
        window.location.reload();
      }
    },
    togglePasswordVisibility() {
      this.shell.passwordVisible = !this.shell.passwordVisible;
    },
    normalizeBackendText(text) {
      if (text == null) {
        return '';
      }

      let normalizedText = String(text);
      normalizedText = normalizedText.replace(/&(amp;)+nbsp;/gi, '&nbsp;');
      normalizedText = normalizedText.replace(/&#160;|&#xA0;/gi, '\u00A0');
      normalizedText = normalizedText.replace(/&nbsp;/gi, '\u00A0');
      return normalizedText;
    },
    formatText(text) {
      const normalized = this.normalizeBackendText(text);
      // Замена переносов строк на <br>
      let formattedText = normalized.replace(/\r?\n/g, '<br>');

      // Поддержка выделения жирным через **text**
      formattedText = formattedText.replace(/\*\*([\s\S]+?)\*\*/g, '<strong>$1</strong>');

      // Регулярное выражение для поиска URL, которые НЕ находятся внутри <a> тегов
      const urlPattern = /(?<!<a href=")(https?:\/\/[^\s]+)(?!")/g;

      // Замена URL на HTML-ссылки
      formattedText = formattedText.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');

      return formattedText;
    },
    clearError(field) {
      this.shell.errors = { ...this.shell.errors, [field]: null };
    },
    clearFeedbackError(field) {
      if (!this.shell.feedbackErrors) {
        this.shell.feedbackErrors = {};
      }
      this.shell.feedbackErrors[field] = '';
    },
    clearLoginError(field) {
      this.shell.loginFormErrors = { ...this.shell.loginFormErrors, [field]: null };
    },
    redirectToPrivatePage() {
      this.$router.push('/private');
      this.isMobileNavOpened = false;
    },
    redirectToHomePage() {
      this.$router.push('/');
    },
    removeSpacesFirstName() {
      const input = event.target.value.trimStart();
      this.shell.registerForm.first_name = input.length > 0 ? input : '';
    },
    removeSpacesLastName() {
      const input = event.target.value.trimStart();
      this.shell.registerForm.last_name = input.length > 0 ? input : '';
    },
    initFloatingLabels() {
      this.$nextTick(() => {
        const floatingFields = document.querySelectorAll('.field-item--floating');
        floatingFields.forEach(fieldItem => {
          const input = fieldItem.querySelector('input, textarea');
          if (!input) return;

          // Функция для проверки и обновления состояния
          const updateFloatingState = () => {
            const hasValue = input.value && input.value.trim().length > 0;
            const hasFocus = document.activeElement === input;
            
            if (hasValue || hasFocus) {
              fieldItem.classList.add('field-item--active');
            } else {
              fieldItem.classList.remove('field-item--active');
            }
          };

          // Удаляем старые обработчики, если они есть
          if (input._floatingHandlers) {
            input.removeEventListener('focus', input._floatingHandlers.focus);
            input.removeEventListener('blur', input._floatingHandlers.blur);
            input.removeEventListener('input', input._floatingHandlers.input);
            input.removeEventListener('change', input._floatingHandlers.change);
          }

          // Создаем новые обработчики
          const focusHandler = () => {
            fieldItem.classList.add('field-item--active');
          };
          const blurHandler = () => {
            updateFloatingState();
          };
          const inputHandler = () => {
            updateFloatingState();
          };
          const changeHandler = () => {
            updateFloatingState();
          };

          // Сохраняем ссылки на обработчики
          input._floatingHandlers = {
            focus: focusHandler,
            blur: blurHandler,
            input: inputHandler,
            change: changeHandler
          };

          // Добавляем обработчики
          input.addEventListener('focus', focusHandler);
          input.addEventListener('blur', blurHandler);
          input.addEventListener('input', inputHandler);
          input.addEventListener('change', changeHandler);

          // Проверяем начальное состояние (без учета фокуса для iOS)
          updateFloatingState();
          requestAnimationFrame(updateFloatingState);
          setTimeout(updateFloatingState, 120);
        });
      });
    },
    removeSpacesName() {
      const input = event.target.value.trimStart();
      this.shell.questionForm.name = input.length > 0 ? input : '';
    },
    formatBirthdayInput(event) {
      let value = event.target.value.replace(/\D/g, ''); // Оставляем только цифры

      // Ограничиваем длину до 8 символов
      if (value.length > 8) {
        value = value.slice(0, 8);
      }

      // Форматируем строку в DD-MM-YYYY
      let formattedValue = value;

      if (value.length >= 2) {
        formattedValue = value.slice(0, 2) + '-' + value.slice(2); // Добавляем дефис после двух первых цифр
      }
      if (value.length >= 5) {
        formattedValue = formattedValue.slice(0, 5) + '-' + formattedValue.slice(5); // Добавляем дефис после пяти символов
      }

      // Удаляем дефис, если длина строки меньше 5 или 2
      if (formattedValue.length < 5) {
        formattedValue = formattedValue.replace('-', '');
      }

      if (formattedValue.length < 2) {
        formattedValue = formattedValue.replace('-', '');
      }

      // Присваиваем форматированное значение в форму
      this.shell.registerForm.birthday = formattedValue;
    },
    convertBirthdayFormat(date) {
      if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
        const [day, month, year] = date.split('-');
        return `${year}-${month}-${day}`;
      }
      return date;
    },
    handleParticipateButtonAuth(participateKind = 'upload') {
      if (blockIfPromoStatusPending()) return;
      // Для авторизованных пользователей: «Участвовать» → Go; «Загрузить чек» → Check_Click
      this.$sendMetrik('reachGoal', participateKind === 'go' ? 'Go' : 'Check_Click');
      if (state.promoStatus == 'start') {
        this.triggerQrScan();
      } else if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoNotStarted = true;
      } else if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoEnd = true;
      }
    },
    handleLoadCheckButton() {
      if (blockIfPromoStatusPending()) return;
      // Для авторизованных пользователей
      this.$sendMetrik('reachGoal', 'Check_Click');
      if (state.promoStatus == 'start') {
        this.triggerQrScan();
      } else if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoNotStarted = true;
      } else if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoEnd = true;
      }
    },
    triggerQrScan() {
      adRiver.trackRegisterReceiptClick();
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'click_upload_check_after_sign_in']);
      }
      if (state.promoStatus == 'start') {
        const qrElement = document.getElementById('apm-scan-qr');
        if (qrElement) {
          state.isUploadOpened = true;
          document.body.classList.add('is-upload-widget-opened');
          qrElement.click();
        }
      }
    },
    triggerQuestionForm() {
      const qrElement = document.getElementById('triggerQuestionForm');
      if (qrElement) {
        qrElement.click();
      }
    },
    toggleMobileNav() {
      this.isMobileNavOpened = !this.isMobileNavOpened;
    },
    handleHeaderNavClick(selector) {
      this.$sendMetrik('reachGoal', 'click_nav');
      this.scrollToSection(selector);
    },
    trackTelegramMainClick() {
      adRiver.trackTelegramBotClick();
      this.$sendMetrik('reachGoal', 'click_tg_main');
    },
    trackStoreClick() {
      this.$sendMetrik('reachGoal', 'click_store');
    },
    handleLinkClick(selector) {
      this.toggleMobileNav(); // Закрываем навигацию
      // Убираем символ "#" из selector перед отправкой в SendMetrick
      // const cleanSelector = selector.replace('#', '');
      // this.SendMetrick(cleanSelector);

      setTimeout(() => { // Добавляем небольшую задержку перед скроллом
        this.scrollToSection(selector);
      }, 300); // Задержка в 300 мс или на ваше усмотрение
    },
    scrollToSection(selector) {
      // selector приходит в виде '#id' или 'id'
      const cleanId = typeof selector === 'string' ? selector.replace('#', '') : '';
      const target = document.getElementById(cleanId) || document.querySelector(selector);

      if (target) {
        // Фиксированный отступ под шапку: высота уменьшенной шапки + запас.
        // Совпадает с _header.scss (8rem/6.2rem при 10px базе) + 40/16 px, чтобы
        // секция оказывалась на одной высоте при любом состоянии шапки.
        const defaultOffset = window.innerWidth <= 767 ? 62 + 16 : 30 + 40;
        // Для якоря гарантированных призов нужен больший зазор, иначе заголовок режется шапкой.
        const guaranteedPrizesOffset = window.innerWidth <= 767 ? 62 + 48 : 30 + 76;
        const scrollOffset = cleanId === 'guaranteed-prizes'
          ? guaranteedPrizesOffset
          : defaultOffset;

        const offsetTop =
          target.getBoundingClientRect().top + window.pageYOffset - scrollOffset;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
    handleHashScroll() {
      // Обработка хеша при загрузке или переходе на страницу
      this.$nextTick(() => {
        // Используем хеш из роута или из window.location
        const hash = this.$route.hash || window.location.hash;
        if (hash) {
          // Дожидаемся полной загрузки страницы и наличия элемента
          this.waitForElementAndScroll(hash, 0);
        }
      });
    },
    waitForElementAndScroll(hash, attempt = 0) {
      const maxAttempts = 20; // Максимум 20 попыток (10 секунд)
      const delay = 500; // Задержка между попытками в мс
      
      const cleanHash = hash.replace('#', '');
      const target = document.getElementById(cleanHash) || document.querySelector(hash);
      
      if (target) {
        // Элемент найден, скроллим к нему
        setTimeout(() => {
          this.scrollToSection(hash);
        }, 100);
      } else if (attempt < maxAttempts) {
        // Элемент еще не загружен, повторяем попытку
        setTimeout(() => {
          this.waitForElementAndScroll(hash, attempt + 1);
        }, delay);
      } else {
        // Превышено количество попыток, пытаемся скроллить в любом случае
        console.warn(`Element ${hash} not found after ${maxAttempts} attempts`);
        setTimeout(() => {
          this.scrollToSection(hash);
        }, 100);
      }
    },
    openAccountPopup() {
      this.addBodyClass();
      this.AccountPopup = true;
    },
    closeAccountPopup() {
      this.removeBodyClass();
      this.AccountPopup = false;
    },
    openQuestionPopup() {
      this.addBodyClass();
      this.shell.showQuestionPopup = true;
      this.shell.responseError = '';
      const fb = feedbackIdentityPrefill(this.user);
      this.shell.questionForm.name = fb.name;
      this.shell.questionForm.email = fb.email;
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeQuestionPopup() {
      this.removeBodyClass();
      this.shell.showQuestionPopup = false;
      this.shell.responseError = '';
      this.resetForm();
      this.shell.filePreviews = [];
      this.shell.questionForm.files = [];
    },
    openQuestionPopupSuccess() {
      // adRiver.trackQuestionFormSubmit()
      this.$sendMetrik('reachGoal', 'Feedback_SentForm_Success');
      this.addBodyClass();
      this.shell.showQuestionPopupSuccess = true;
      this.shell.showQuestionPopup = false;
      this.resetForm();
      this.shell.formSending = false;
    },
    closeQuestionPopupSuccess() {
      this.removeBodyClass();
      this.shell.showQuestionPopupSuccess = false;
      this.resetForm();
    },
    closeEndPopupSuccess() {
      this.removeBodyClass();
      this.showEndPopupSuccess = false;
      this.resetForm();
    },
    openResetPasswordPopup() {
      if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.responseError = '';
        this.shell.showPromoNotStarted = true;
        return;
      }
      this.shell.resetPasswordForm.email = '';
      this.shell.resetPasswordErrors = {};
      this.shell.responseError = '';
      this.shell.showResetPasswordPopup = true;
      this.closeLoginPopup();
      this.addBodyClass();
    },
    closeResetPasswordPopup() {
      this.removeBodyClass();
      this.shell.showResetPasswordPopup = false;
      this.resetForm();
    },
    openResetPasswordPopupSuccess() {
      this.addBodyClass();
      this.shell.showResetPasswordSuccess = true;
    },
    closeResetPasswordPopupSuccess() {
      this.shell.resetPasswordEmail = null;
      this.removeBodyClass();
      this.shell.showResetPasswordSuccess = false;
      this.resetForm();
    },
    closeShowPromoNotStarted() {
      this.removeBodyClass();
      this.shell.showPromoNotStarted = false;
    },
    closeShowPromoEnd() {
      this.removeBodyClass();
      this.shell.showPromoEnd = false;
    },
    async submitQuestion() {
      try {
        this.shell.formSending = true;
        this.shell.feedbackErrors = {};

        // Валидация формы
        if (!this.shell.questionForm.name || this.shell.questionForm.name.trim().length < 2) {
          this.shell.feedbackErrors.name = 'Введите имя (минимум 2 символа)';
        }
        if (!this.shell.questionForm.email || !this.shell.questionForm.email.trim()) {
          this.shell.feedbackErrors.email = 'Поле обязательно для заполнения';
        } else if (!this.isEmailStrictValid(this.shell.questionForm.email)) {
          this.shell.feedbackErrors.email = 'Введите корректный email';
        }
        const textTrimmed = (this.shell.questionForm.text || '').trim();
        if (!textTrimmed) {
          this.shell.feedbackErrors.text = 'Введите Сообщение';
        } else if (textTrimmed.length < 2) {
          this.shell.feedbackErrors.text = 'Поле обязательно для заполнения';
        } else if (textTrimmed.length > 600) {
          this.shell.feedbackErrors.text = 'Текст обращения не более 600 символов';
        }
        if (!this.shell.questionForm.agree_personal_data) {
          this.shell.feedbackErrors.agree_personal_data = 'Необходимо согласиться на обработку персональных данных';
        } else {
          // Удаляем ошибку, если чекбокс отмечен
          delete this.shell.feedbackErrors.agree_personal_data;
        }
        if (!this.shell.questionForm.subject || this.shell.questionForm.subject === 'Выберите тему') {
          this.shell.feedbackErrors.subject = 'Выберите тему';
        }

        // Проверяем наличие ошибок (только непустые значения)
        const hasErrors = Object.keys(this.shell.feedbackErrors).some(key => this.shell.feedbackErrors[key] && this.shell.feedbackErrors[key] !== '');
        if (hasErrors) {
          this.shell.formSending = false;
          return;
        }

        // Отправка данных формы через API
        await sendFeedback({
          email: this.shell.questionForm.email,
          name: this.shell.questionForm.name,
          text: this.shell.questionForm.text,
          subject: this.shell.questionForm.subject,
          agree_personal_data: this.shell.questionForm.agree_personal_data,
          agree_to_advertising: this.shell.questionForm.agree_to_advertising,
          files: this.shell.questionForm.files
        });
        this.openQuestionPopupSuccess();
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    validateResetPasswordEmail() {
      const email = this.shell.resetPasswordForm.email;
      
      if (!this.shell.resetPasswordErrors) {
        this.shell.resetPasswordErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.shell.resetPasswordErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        this.shell.resetPasswordErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.shell.resetPasswordErrors.email = '';
    },
    async submitResetPassword() {
      try {
        this.shell.formSending = true;
        const { email } = this.shell.resetPasswordForm;
        this.shell.resetPasswordErrors = {};
        this.shell.responseError = '';

        // Валидация email
        this.validateResetPasswordEmail();
        
        // Если есть ошибки валидации - не отправляем
        if (this.shell.resetPasswordErrors.email) {
          this.shell.formSending = false;
          return;
        }

        // Отправка данных формы через API
        await sendResetPassword({ email: email });

        // Успешная отправка, здесь можно закрыть попап
        this.shell.resetPasswordEmail = email;
        this.closeResetPasswordPopup();
        this.openResetPasswordPopupSuccess();
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    resetForm() {
      this.shell.formSending = false;
      this.shell.responseError = '';
      this.shell.errors = {};
      this.shell.loginFormErrors = {};
      this.shell.feedbackErrors = {};
      this.shell.resetPasswordErrors = {};
      this.shell.filePreviews = [];
      const fb = feedbackIdentityPrefill(this.user);
      this.shell.questionForm = {
        name: fb.name,
        email: fb.email,
        text: '',
        subject: '',
        agree_personal_data: false,
        files: []
      };
      this.shell.selectedText = 'Тема обращения';
      this.shell.isChange = false;
      this.phone_number = '';
      this.shell.password = '';

      this.shell.registerForm = {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        is_policy: false,
        agree_rules: false,
        agree_to_advertising: false
      };

      this.shell.resetPasswordForm = {
        email: '',
      };
    },
    toggleAccordion(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    handleScrollThrottled() {
      if (this._handleScrollRafId) return;
      this._handleScrollRafId = requestAnimationFrame(() => {
        this._handleScrollRafId = null;
        this.handleScroll();
      });
    },
    handleScroll() {
      this.isHeaderScrolled = window.scrollY > this.scrollThreshold;
      this.updateHowScrollState();
      this.handleWindowScrollForWinners();
    },
    updateHowScrollState() {
      if (!this.isHowMobileView || !this.$refs.howSection) {
        this.isHowPinned = false;
        return;
      }

      const outer = this.$refs.sectionsStickyOuter;
      if (!outer) {
        this.isHowPinned = false;
        return;
      }

      const outerRect = outer.getBoundingClientRect();
      const stepPx = this.getHowSlideStepPx();
      const maxIndex = Math.max(0, this.howSlidesCount - 1);
      let targetIndex = 0;

      if (outerRect.top <= 0) {
        const passed = Math.max(0, -outerRect.top);
        targetIndex = Math.min(maxIndex, Math.floor(passed / stepPx));
      }

      this.isHowPinned = outerRect.top <= 0 && outerRect.bottom > 0;

      if (this.howSwiper && targetIndex !== this.activeHowSlide) {
        this.goToHowSlide(targetIndex);
      }
    },
    getHowSlideStepPx() {
      const viewportHeight = Math.max(
        1,
        Math.round(window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 1)
      );
      return Math.max(1, Math.round(viewportHeight * 0.9));
    },
    scrollToHowSlide(slideIndex) {
      if (!this.isHowMobileView) {
        return;
      }

      const boundedSlide = Math.min(this.howSlidesCount - 1, Math.max(0, slideIndex));
      this.goToHowSlide(boundedSlide);
      const outer = this.$refs.sectionsStickyOuter;
      if (!outer) {
        return;
      }
      const stepPx = this.getHowSlideStepPx();
      const outerTop = outer.getBoundingClientRect().top + window.pageYOffset;
      const targetY = Math.max(0, outerTop + (boundedSlide * stepPx));
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    },
    goToHowSlide(slideIndex) {
      if (!this.isHowMobileView || !this.howSwiper) {
        return;
      }

      const boundedSlide = Math.min(this.howSlidesCount - 1, Math.max(0, slideIndex));
      this.activeHowSlide = boundedSlide;
      this.howSwiper.slideTo(boundedSlide);
    },
    onHowSwipeStart(event) {
      if (!this.isHowMobileView || !event.touches || !event.touches.length) {
        return;
      }

      const touch = event.touches[0];
      this.howSwipeStartX = touch.clientX;
      this.howSwipeStartY = touch.clientY;
      this.howSwipeCurrentX = touch.clientX;
      this.howSwipeCurrentY = touch.clientY;
      this.howSwipeActive = true;
    },
    onHowSwipeMove(event) {
      if (!this.isHowMobileView || !this.howSwipeActive || !event.touches || !event.touches.length) {
        return;
      }

      const touch = event.touches[0];
      this.howSwipeCurrentX = touch.clientX;
      this.howSwipeCurrentY = touch.clientY;
    },
    onHowSwipeEnd() {
      if (!this.isHowMobileView || !this.howSwipeActive) {
        return;
      }

      const deltaX = this.howSwipeCurrentX - this.howSwipeStartX;
      const deltaY = this.howSwipeCurrentY - this.howSwipeStartY;
      const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      const swipeThreshold = 40;

      if (isHorizontalSwipe && Math.abs(deltaX) >= swipeThreshold) {
        const direction = deltaX < 0 ? 1 : -1;
        this.goToHowSlide(this.activeHowSlide + direction);
      }

      this.howSwipeActive = false;
    },
    isHowScrollLockZone() {
      if (!this.isHowMobileView || !this.$refs.howSection) {
        return false;
      }
      if (document.body.classList.contains('noscroll')) {
        return false;
      }

      const rect = this.$refs.howSection.getBoundingClientRect();
      const header = document.querySelector('header');
      const headerOffset = header ? header.offsetHeight : 0;
      // Входим в lock чуть раньше, чтобы не было позднего "скачка" к пину.
      const enterTopTolerance = 300;
      const bottomTolerance = 12;
      return rect.top <= headerOffset + enterTopTolerance && rect.bottom > headerOffset + bottomTolerance;
    },
    isHowBoundaryForDirection(direction) {
      const maxIndex = this.howSlidesCount - 1;
      return direction > 0
        ? this.activeHowSlide >= maxIndex
        : this.activeHowSlide <= 0;
    },
    enableHowPageLock() {
      if (this.howPageLockActive || document.body.classList.contains('noscroll')) {
        return;
      }
      this.howPageLockScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.overscrollBehaviorY = 'none';
      document.documentElement.style.touchAction = 'none';
      document.body.style.overscrollBehaviorY = 'none';
      document.body.style.touchAction = 'none';
      this.howPageLockActive = true;
      this.howJustLockedUntil = Date.now() + 220;
      this.howSoftLockUntil = Date.now() + 180;
      this.howWheelDeltaAcc = 0;
      this.howWheelDeltaDir = 0;
      this.howTouchDeltaAcc = 0;
      this.howTouchDeltaDir = 0;
      // Держим позицию секции сразу после активации lock.
      // Короткая "мягкая" фаза без принудительного прыжка, чтобы не было резкого bаm.
    },
    disableHowPageLock() {
      if (!this.howPageLockActive) {
        return;
      }
      document.documentElement.style.overscrollBehaviorY = '';
      document.documentElement.style.touchAction = '';
      document.body.style.overscrollBehaviorY = '';
      document.body.style.touchAction = '';
      this.howPageLockActive = false;
      this.howPageLockScrollY = 0;
      this.howJustLockedUntil = 0;
      this.howSoftLockUntil = 0;
    },
    stepHowSlideWithLock(direction) {
      if (!this.isHowScrollLockZone()) {
        this.disableHowPageLock();
        this.howWheelDeltaAcc = 0;
        this.howWheelDeltaDir = 0;
        this.howTouchDeltaAcc = 0;
        this.howTouchDeltaDir = 0;
        return false;
      }

      const maxIndex = this.howSlidesCount - 1;
      const atBoundary = direction > 0
        ? this.activeHowSlide >= maxIndex
        : this.activeHowSlide <= 0;

      if (atBoundary) {
        this.disableHowPageLock();
        this.howWheelDeltaAcc = 0;
        this.howWheelDeltaDir = 0;
        this.howTouchDeltaAcc = 0;
        this.howTouchDeltaDir = 0;
        return false;
      }

      this.enableHowPageLock();
      const now = Date.now();
      if (now < this.howJustLockedUntil) {
        return true;
      }
      if (now < this.howSlideLockUntil) {
        return true;
      }

      this.goToHowSlide(this.activeHowSlide + direction);
      this.howSlideLockUntil = now + 320;
      return true;
    },
    onHowLockWheel(event) {
      if (!this.isHowMobileView) {
        return;
      }
      if (!this.isHowScrollLockZone()) {
        this.disableHowPageLock();
        this.howWheelDeltaAcc = 0;
        this.howWheelDeltaDir = 0;
        return;
      }
      const deltaY = Number(event?.deltaY || 0);
      if (Math.abs(deltaY) < 4) {
        return;
      }

      const direction = deltaY > 0 ? 1 : -1;
      if (this.isHowBoundaryForDirection(direction)) {
        this.disableHowPageLock();
        this.howWheelDeltaAcc = 0;
        this.howWheelDeltaDir = 0;
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      if (this.howWheelDeltaDir !== direction) {
        this.howWheelDeltaDir = direction;
        this.howWheelDeltaAcc = 0;
      }

      this.howWheelDeltaAcc += Math.abs(deltaY);
      const wheelStepThreshold = 180;
      if (this.howWheelDeltaAcc < wheelStepThreshold) {
        this.enableHowPageLock();
        return;
      }

      this.howWheelDeltaAcc = 0;
      this.stepHowSlideWithLock(direction);
    },
    onHowLockTouchStart(event) {
      if (!this.isHowMobileView || !event.touches || !event.touches.length) {
        return;
      }
      this.howTouchLastY = event.touches[0].clientY;
    },
    onHowLockTouchMove(event) {
      if (!this.isHowMobileView || !event.touches || !event.touches.length) {
        return;
      }
      if (!this.isHowScrollLockZone()) {
        this.disableHowPageLock();
        this.howTouchDeltaAcc = 0;
        this.howTouchDeltaDir = 0;
        this.howTouchLastY = event.touches[0].clientY;
        return;
      }

      const currentY = event.touches[0].clientY;
      if (!this.howTouchLastY) {
        this.howTouchLastY = currentY;
        return;
      }

      const deltaY = currentY - this.howTouchLastY;
      if (Math.abs(deltaY) < 10) {
        return;
      }

      const direction = deltaY < 0 ? 1 : -1;
      if (this.isHowBoundaryForDirection(direction)) {
        this.disableHowPageLock();
        this.howTouchDeltaAcc = 0;
        this.howTouchDeltaDir = 0;
        this.howTouchLastY = currentY;
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      if (this.howTouchDeltaDir !== direction) {
        this.howTouchDeltaDir = direction;
        this.howTouchDeltaAcc = 0;
      }

      this.howTouchDeltaAcc += Math.abs(deltaY);
      const touchStepThreshold = 90;
      if (this.howTouchDeltaAcc < touchStepThreshold) {
        this.enableHowPageLock();
        this.howTouchLastY = currentY;
        return;
      }

      this.howTouchDeltaAcc = 0;
      this.stepHowSlideWithLock(direction);

      this.howTouchLastY = currentY;
    },
    onHowLockTouchEnd() {
      this.howTouchLastY = 0;
      this.howTouchDeltaAcc = 0;
      this.howTouchDeltaDir = 0;
    },
    async checkAuthentication() {
      const token = getToken();
      if (token) {
        try {
          const userInfo = await getUserInfo();
          this.user = userInfo;
          state.user = {
            address: {
              apartment: userInfo.address?.apartment ?? "",
              city: userInfo.address?.city ?? "",
              email: userInfo.address?.email ?? "",
              fio: userInfo.address?.fio ?? "",
              house: userInfo.address?.house ?? "",
              phone_number: userInfo.address?.phone_number ?? "",
              street: userInfo.address?.street ?? "",
              zip_code: userInfo.address?.zip_code ?? "",
            },

            id: userInfo.id,
            uuid: userInfo.uuid,
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            phone_number: userInfo.phone_number,
            email: userInfo.email,
            gender: userInfo.gender ?? null,
            is_verification: userInfo.is_verification ?? null,
            birthday: userInfo.birthday,
            is_possible_to_upload_receipt: userInfo.is_possible_to_upload_receipt,
            address_is_filled: userInfo.address_is_filled,
            promocode: userInfo.promocode,
            referral_id: userInfo.referral_id,
            referral_link: userInfo.referral_link,
            balance: userInfo.balance,
            privilege_level: userInfo.privilege_level,
            need_points: userInfo.need_points,
            checks_count: userInfo.checks_count,
            approved_checks_count: userInfo.approved_checks_count,
            rejected_checks_count: userInfo.rejected_checks_count,
            all_cash: userInfo.all_cash
          }
          // this.executeDSPCounterEvent('login_success');
          this.shell.questionForm.name = userInfo.first_name;
          this.shell.questionForm.email = userInfo.email;
        } catch (error) {
          if (error.response && error.response.data) {
            this.shell.responseError = error.response.data.detail;
          }
        }
      }
    },
    formatDateRange(start_date, end_date) {
      const start = new Date(start_date);
      const end = new Date(end_date);

      const format = (date) =>
          String(date.getUTCDate()).padStart(2, "0") + "." +
          String(date.getUTCMonth() + 1).padStart(2, "0") + "." +
          date.getUTCFullYear();

      return `${format(start)} – ${format(end)}`;
    },
    formatDateStart(start_date) {
      const start = new Date(start_date);

      return String(start.getUTCDate()).padStart(2, "0") + "." +
          String(start.getUTCMonth() + 1).padStart(2, "0") + "." +
          start.getUTCFullYear();
    },
    formatDateEnd(end_date) {
      const end = new Date(end_date);

      return String(end.getUTCDate()).padStart(2, "0") + "." +
          String(end.getUTCMonth() + 1).padStart(2, "0") + "." +
          end.getUTCFullYear();
    },
    async fetchTimerData() {
      try {
        const { start_date, end_date, status } = await getMainSettings();
        const now = new Date();
        const startDate = new Date(start_date);
        const endDate = new Date(end_date);
        const mappedStatus = status === 'future'
          ? 'not-started'
          : status === 'active'
            ? 'start'
            : status === 'past'
              ? 'end'
              : '';

        if (now >= endDate || mappedStatus === 'end') {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        } else if (now < startDate || mappedStatus === 'not-started') {
          this.calculateTimeDifference(now, startDate);
          this.timerMessage = 'до начала акции';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'not-started'
          state.promoStart = start_date;
          state.promoStart = this.formatDateStart(start_date);
        } else if (mappedStatus === 'start' || (!mappedStatus && now >= startDate && now < endDate)) {
          this.calculateTimeDifference(now, endDate);
          this.timerMessage = 'До окончания приема чеков';
          this.promoDates = start_date + ' - ' + end_date;
          state.promoStatus = 'start'
        } else {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.timerMessage = 'Акция завершилась';
          this.promoDates = startDate + ' - ' + end_date;
          state.promoStatus = 'end'
          state.promoEnd = this.formatDateEnd(end_date);
        }
        this.promoDates = this.formatDateRange(start_date, end_date);

        const promoShown = sessionStorage.getItem('promoShown');
        if (!promoShown && state.promoStatus === 'end') {
          this.shell.showPromoEnd = true;
          sessionStorage.setItem('promoShown', 'true');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      } finally {
        markPromoStatusLoaded();
      }
    },
    calculateTimeDifference(start, end) {
      const diff = end - start;

      // Переводим разницу в миллисекундах в дни, часы и минуты
      const totalSeconds = Math.floor(diff / 1000);
      this.days = Math.floor(totalSeconds / (3600 * 24));
      this.hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      this.minutes = Math.floor((totalSeconds % 3600) / 60);
    },
    onHowToPlayClick() {
      if (blockIfPromoStatusPending()) return;
      this.$sendMetrik('reachGoal', 'Play');
      if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.shell.showPromoNotStarted = true;
        return;
      }
      if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.shell.showPromoEnd = true;
        return;
      }
      this.scrollToSection('interactive');
    },
    async loadInteractiveRiceProgress() {
      if (!getToken()) {
        this.interactiveWonRiceList = [];
        this.interactiveWonRiceChainAccess = 'available';
        return;
      }
      try {
        setAuthHeader();
        const data = await fetchWonRiceGames();
        const { items, chainAccess } = parseWonRiceGamesResponse(data);
        this.interactiveWonRiceChainAccess = chainAccess;
        const base = Array.isArray(items) ? items : [];
        this.interactiveWonRiceList = mergePendingIntoWonRiceList(base);
      } catch (e) {
        this.interactiveWonRiceList = [];
        this.interactiveWonRiceChainAccess = 'available';
      }
    },
    async handleInteractiveBlockPlay() {
      if (blockIfPromoStatusPending()) return;
      this.$sendMetrik('reachGoal', 'Play');
      if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.shell.showPromoNotStarted = true;
        return;
      }
      if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.shell.showPromoEnd = true;
        return;
      }
      if (!getToken()) {
        this.openCommonLoginPopup();
        return;
      }
      await this.loadInteractiveRiceProgress();
      this.addBodyClass();
      this.showAccountInteractivePopup = true;
    },
    closeAccountInteractivePopup() {
      this.showAccountInteractivePopup = false;
      this.removeBodyClass();
      void this.loadInteractiveRiceProgress();
    },
    onAccountInteractiveHomeUploadCheck() {
      this.$sendMetrik('reachGoal', 'Check_Click');
      this.closeAccountInteractivePopup();
      this.handleLoadCheckButton();
    },
    isPastMainSettingsEndDate() {
      const raw = this.mainSettings?.end_date;
      if (!raw) return false;
      const t = new Date(raw).getTime();
      return !Number.isNaN(t) && Date.now() >= t;
    },
    handleParticipateButton(participateKind = 'upload') {
      if (blockIfPromoStatusPending()) return;
      // this.executeAdriverEvent('go');
      adRiver.trackRegisterReceiptClick();
      this.$sendMetrik('reachGoal', participateKind === 'go' ? 'Go' : 'Check_Click');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'click_upload_check']);
      }
      
      // Проверяем статус акции
      if (state.promoStatus == 'not-started') {
        this.addBodyClass();
        this.shell.showPromoNotStarted = true;
      } else if (state.promoStatus == 'end') {
        this.addBodyClass();
        this.shell.showPromoEnd = true;
      } else {
        this.openCommonLoginPopup();
      }
    },
    handleUploadCheckMainGuest() {
      if (blockIfPromoStatusPending()) return;
      adRiver.trackRegisterReceiptClick();
      this.$sendMetrik('reachGoal', 'Check_Click');
      if (state.promoStatus == 'end' || this.isPastMainSettingsEndDate()) {
        this.addBodyClass();
        this.shell.showPromoEnd = true;
        return;
      }
      if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.shell.showPromoNotStarted = true;
        return;
      }
      this.openCommonLoginPopup();
    },
    openLoginPopup() {
      if (blockIfPromoStatusPending()) return;
      this.shell.email = '';
      this.shell.password = '';
      this.shell.loginFormErrors = {};
      this.shell.responseError = '';
      this.shell.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      if (state.promoStatus == 'start' || state.promoStatus == 'end' || this.isPastMainSettingsEndDate()) {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showLoginPopup = true;
        this.$nextTick(() => {
          this.initFloatingLabels();
        });
      } else if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.responseError = '';
        this.shell.showPromoNotStarted = true;
      }
    },
    closeLoginPopup() {
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'enter_сancel']);
      }
      this.removeBodyClass();
      this.shell.showLoginPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    closeCommonLoginPopup() {
      this.shell.showCommonLoginPopup = false;
      state.showCommonLoginPopup = false;
      this.removeBodyClass();
      this.shell.responseError = '';
      this.resetForm();
    },
    openRegisterPopup() {
      if (this.shell?.openRegisterPopup) {
        this.shell.openRegisterPopup();
      }
    },
    openCommonLoginPopup() {
      if (blockIfPromoStatusPending()) return;
      this.shell.responseError = '';
      if (state.promoStatus == 'not-started' || state.promoStatus == 'future') {
        this.addBodyClass();
        this.isMobileNavOpened = false;
        this.shell.showPromoNotStarted = true;
        return;
      }
      this.shell.showCommonLoginPopup = true;
      state.showCommonLoginPopup = true;
      this.addBodyClass();
      this.$nextTick(() => {
        this.initFloatingLabels();
      });
    },
    closeRegisterPopup() {
      this.$sendMetrik('reachGoal', 'SignUp_Cancel');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_сancel']);
      }
      // this.executeAdriverEvent('close_registration');
      this.removeBodyClass();
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    closeRegisterFinishPopup() {
      this.removeBodyClass();
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    openRegisterPopupSuccess() {
      adRiver.trackUserRegistrationSuccess();
      this.$sendMetrik('reachGoal', 'SignUp_SentForm_Success');
      if (typeof _txq !== 'undefined') {
        _txq.push(['track', 'registration_success']);
      }
      // this.executeAdriverEvent('signup_sentform_success');
      this.addBodyClass();
      this.shell.showRegisterPopupSuccess = true;
      this.shell.responseError = '';
    },
    closeRegisterPopupSuccess() {
      this.removeBodyClass();
      this.shell.showRegisterPopupSuccess = false;
      this.shell.responseError = '';
      this.resetForm();
    },
    openLoginFromRegisterSuccess() {
      this.shell.showRegisterPopupSuccess = false;
      this.shell.responseError = '';
      this.resetForm();
      this.addBodyClass();
      this.shell.showLoginPopup = true;
    },
    async loadFAQ() {
      try {
        const data = await fetchFAQ();
        this.faq = data.results.map(item => ({
          question: this.normalizeBackendText(item.question),
          answer: this.normalizeBackendText((item.answer || '').replace("{rules_link}", this.mainSettings.rules))
        }));
      } catch (error) {
        console.error('Error fetching FAQ:', error);
      }
    },
    validateLoginEmail() {
      const email = this.shell.email;
      
      if (!this.shell.loginFormErrors) {
        this.shell.loginFormErrors = {};
      }
      
      if (!email || email.trim() === '') {
        this.shell.loginFormErrors.email = 'Поле обязательно для заполнения';
        return;
      }
      
      // Строгая валидация email
      if (!this.isEmailStrictValid(email)) {
        this.shell.loginFormErrors.email = 'Введите корректный email';
        return;
      }
      
      // Если все проверки пройдены, очищаем ошибку
      this.shell.loginFormErrors.email = '';
    },
    validateLoginPassword() {
      const password = this.shell.password;

      if (!this.shell.loginFormErrors) {
        this.shell.loginFormErrors = {};
      }

      if (!password || password.trim() === '') {
        this.shell.loginFormErrors.password = 'Поле обязательно для заполнения';
        return;
      }

      if (password.length < 6) {
        this.shell.loginFormErrors.password = 'Пароль должен быть не менее 6 символов';
        return;
      }

      this.shell.loginFormErrors.password = '';
    },
    async login() {
      try {
        this.shell.formSending = true;
        this.shell.loginFormErrors = {};
        this.shell.responseError = '';
        
        // Валидация email
        this.validateLoginEmail();
        
        // Валидация пароля
        this.validateLoginPassword();
        
        // Если есть ошибки - не отправляем запрос
        if (this.shell.loginFormErrors.email || this.shell.loginFormErrors.password) {
          this.shell.formSending = false;
          return;
        }

        await authorize(this.shell.email, this.shell.password);
        setAuthHeader();
        setTimeout(async () => {
          try {
            const userInfo = await getUserInfo();
            if (userInfo) {
              // adRiver.trackAuthorization()
              this.$sendMetrik('reachGoal', 'SignIn_SentForm_Success');
              if (typeof _txq !== 'undefined') {
                _txq.push(['track', 'enter_success']);
              }
              this.userId = userInfo.id;
              this.userUuid = userInfo.uuid;
              this.user = {
                first_name: userInfo.first_name,
                last_name_initial: (userInfo.last_name || '').charAt(0),
                email: userInfo.email,
              };
              this.shell.questionForm.name = userInfo.first_name;
              this.shell.questionForm.email = userInfo.email;
              this.closeLoginPopup();
              this.removeBodyClass();
              // this.initQrWidget();
              // this.executeDSPCounterEvent('login_success');
              setTimeout(() => {
                this.$router.push('/private');
              }, 500)
            }
          } catch (error) {
            console.error('Error fetching user info', error);
          }
          this.shell.formSending = false;
        }, 500); // 500 мс задержка

      } catch (error) {
        this.shell.formSending = false;
        if (error.response.status === 553 || error.response.status === 554) {
          this.shell.responseError = 'неверный логин или пароль';
        } else if (error.response && error.response.data) {
          this.shell.responseError = error.response.data.detail;
        }
      }
    },
    async register() {
      try {
        this.shell.formSending = true;
        const { first_name, last_name, phone_number, email, agree_rules, agree_to_advertising } = this.shell.registerForm;
        this.shell.registrationSuccessEmail = (email || '').trim();

        const formattedPhoneNumber = formatRussianMobileE164(phone_number);

        // Проверки
        this.shell.errors = {};
        if (registerNameSignificantLength(first_name) < 2) {
          this.shell.errors.first_name = 'Введите имя (минимум 2 символа)';
        }
        if (registerNameSignificantLength(last_name) < 2) {
          this.shell.errors.last_name = 'Введите фамилию (минимум 2 символа)';
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          this.shell.errors.email = 'Поле обязательно для заполнения';
        }
        if (!formattedPhoneNumber) {
          this.shell.errors.phone_number = russianMobilePhoneHint();
        }
        if (!agree_rules) {
          this.shell.errors.agree_rules = 'Необходимо согласиться с правилами акции';
        }
        // Если есть ошибки - не отправляем
        if (Object.keys(this.shell.errors).length > 0) {
          this.shell.formSending = false;
          return;
        }

        // Получаем registration_params из localStorage или текущих utmParams
        let registrationParamsString = '';
        const savedParams = localStorage.getItem('registration_params');
        if (savedParams) {
          registrationParamsString = savedParams;
        } else if (Object.keys(this.utmParams).length > 0) {
          registrationParamsString = new URLSearchParams(this.utmParams).toString();
        }

        // Отправляем запрос с форматированной датой
        // registration_params должен быть строкой согласно документации API
        await register({
          first_name: (first_name || '').trim(),
          last_name: (last_name || '').trim(),
          phone_number: formattedPhoneNumber,
          email,
          registration_params: registrationParamsString || null,
          agree_to_advertising,
          is_policy: true,
          is_rules: agree_rules,
        });

        this.closeRegisterFinishPopup();
        // После регистрации не логиним автоматически — показываем стандартный попап.
        this.openRegisterPopupSuccess();
        state.ref = '';
        this.shell.formSending = false;
      } catch (error) {
        this.shell.formSending = false;
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          this.shell.responseError = formatApiErrorResponseMessage(
            errorData,
            'Произошла ошибка при регистрации'
          );
          if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
            const skip = new Set(['detail', 'message', 'non_field_errors']);
            Object.keys(errorData).forEach((field) => {
              if (skip.has(field) || this.shell.errors[field]) return;
              const v = errorData[field];
              this.shell.errors[field] = Array.isArray(v) ? v.join(', ') : v;
            });
          }
        } else {
          this.shell.responseError = 'Произошла ошибка при регистрации. Попробуйте позже.';
        }
      }
    },
    switchToLogin() {
      this.addBodyClass();
      this.shell.showResetPasswordSuccess = false;
      this.shell.showLoginPopup = true;
      this.shell.showRegisterPopup = false;
      this.shell.responseError = '';
      this.shell.formSending = false;
      this.resetForm();
    }
  },
};
</script>

<style>
/* Ваши стили */
</style>
